<template>
  <div>
    <v-snackbar v-model="snackbar.status" :color="snackbar.color" :timeout="snackbar.timeout" dark>
      <span class="font-weight-bold">{{snackbar.text}}</span>
      <template v-slot:action="{ attrs }">
        <v-btn
            class="font-weight-bold"
            color="white"
            text
            v-bind="attrs"
            @click="snackbar.status = false"
        >Fechar</v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialogFiliais" max-width="1224" :fullscreen="$vuetify.breakpoint.width<450" scrollable>
      <v-card elevation="0">
        <v-card-title class="primary white--text pt-4 pr-3" v-if="busca.mes">
          {{mesesNomes[busca.mes-1].apelido}} de {{ano - 1}} X {{tituloDialog}} de {{ano}}
          <v-spacer/>
          <v-btn color="white" icon @click="dialogFiliais = false" class="mt-n1 mr-n1"> <v-icon> mdi-close </v-icon> </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="pa-0">
          <v-simple-table v-if="$vuetify.breakpoint.mdAndUp" dense fixed-header :height="busca.idfiliais && busca.idfiliais.length>15?'70vh':''">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-truncate">ID</th>
                <th class="text-truncate">Filial</th>
                <th class="text-center">Qtde de Tickets A.A</th>
                <th class="text-center">Qtde de Tickets Mês</th>
                <th class="text-center">% Var. Tickets</th>
                <th class="text-center">Qtde de Clientes A.A</th>
                <th class="text-center">Qtde de Clientes Mês</th>
                <th class="text-center">% Var. Clientes</th>
              </tr>
              </thead>
              <tbody>
              <template v-if="dadosFiliais">
                <tr v-for="(u, i) in dadosFiliais" :key="i">
                  <td>{{u.idempresa}}</td>
                  <td>{{u.empresa}}</td>
                  <td class="text-center">{{formataNumero(u.qtd_vendas_aa)}}</td>
                  <td class="text-center">{{formataNumero(u.qtd_vendas) }}</td>
                  <td class="text-center font-weight-medium" :class="corVariacao(u.var_qtd_vendas_aa)">{{ formataPercentual(u.var_qtd_vendas_aa, true) }} %</td>
                  <td class="text-center">{{formataNumero(u.qtd_clientes_aa) }}</td>
                  <td class="text-center">{{formataNumero(u.qtd_clientes) }}</td>
                  <td class="text-center font-weight-medium" :class="corVariacao(u.var_qtd_vendas_aa)">{{ formataPercentual(u.var_qtd_clientes_aa, true) }} %</td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td class="text-center" colspan="6">Nenhum registro encontrado.</td>
                </tr>
              </template>
              </tbody>
              <tfoot style="background-color: #f4f4f4; position: sticky; bottom: 0; z-index: 2;">
              <tr class="font-weight-bold">
                <td colspan="2" class="text-right" style="height:40px;">Total:</td>
                <td class="text-center">{{  formataNumero(dadosFiliais.reduce((sum, u) => sum + u.qtd_vendas_aa, 0)) }} </td>
                <td class="text-center">{{  formataNumero(dadosFiliais.reduce((sum, u) => sum + (u.qtd_vendas || 0), 0)) }} </td>
                <td
                    class="text-center"
                    :class="corVariacao(((dadosFiliais.reduce((sum, u) => sum + (u.qtd_vendas || 0), 0) - dadosFiliais.reduce((sum, u) => sum + (u.qtd_vendas_aa || 0), 0)) / dadosFiliais.reduce((sum, u) => sum + (u.qtd_vendas_aa || 0), 0)*100))"
                >
                  {{  ((dadosFiliais.reduce((sum, u) => sum + (u.qtd_vendas || 0), 0)
                    - dadosFiliais.reduce((sum, u) => sum + (u.qtd_vendas_aa || 0), 0))
                    / dadosFiliais.reduce((sum, u) => sum + (u.qtd_vendas_aa || 0), 0)*100).toFixed(2) }} %
                </td>
                <td class="text-center">{{  formataNumero(dadosFiliais.reduce((sum, u) => sum + (u.qtd_clientes_aa || 0), 0)) }} </td>
                <td class="text-center">{{  formataNumero(dadosFiliais.reduce((sum, u) => sum + (u.qtd_clientes || 0), 0)) }} </td>
                <td class="text-center" :class="corVariacao(((dadosFiliais.reduce((sum, u) => sum + (u.qtd_clientes || 0), 0) - dadosFiliais.reduce((sum, u) => sum + (u.qtd_clientes_aa || 0), 0)) / dadosFiliais.reduce((sum, u) => sum + (u.qtd_clientes_aa || 0), 0) *100))">
                  {{  ((dadosFiliais.reduce((sum, u) => sum + (u.qtd_clientes || 0), 0) - dadosFiliais.reduce((sum, u) => sum + (u.qtd_clientes_aa || 0), 0)) / dadosFiliais.reduce((sum, u) => sum + (u.qtd_clientes_aa || 0), 0) *100).toFixed(2) }} %
                </td>
              </tr>
              </tfoot>
            </template>
          </v-simple-table>
          <v-row v-else>
            <v-col v-for="(item, index) in dadosFiliais" :key="index" cols="12" class="pb-0">
              <v-card outlined>
                <v-card-subtitle class="text-center pa-1 font-weight-bold" style="background-color: #f4f4f4">
                  {{ item.idempresa }} - {{ item.empresa }}
                </v-card-subtitle>
                <v-card-text class="pa-0">
                  <v-row no-gutters>
                    <v-col cols="6" class="text-center bordered-col py-1">
                      <strong> Qtde de Tickets AA: </strong> <v-spacer/> {{item.qtd_vendas_aa }} <br/>
                    </v-col>
                    <v-col cols="6" class="text-center bordered-col py-1">
                      <strong> Qtde de Tickets: </strong> <v-spacer/>{{ item.qtd_vendas }}<br/>
                    </v-col>
                    <v-col cols="12" class="text-center bordered-col py-1">
                      <strong> % Var. Qtde de Tickets : </strong> <v-spacer/>
                      <span :class="corVariacao(item.var_qtd_vendas_aa)" class="font-weight-medium">{{ formataPercentual(item.var_qtd_vendas_aa) }}</span>
                    </v-col>
                    <v-col cols="6" class="text-center bordered-col py-1">
                      <strong> Qtde de Clientes AA: </strong> <v-spacer/>{{ item.qtd_clientes_aa }}<br/>
                    </v-col>
                    <v-col cols="6" class="text-center bordered-col py-1">
                      <strong> Qtde de Clientes: </strong> <v-spacer/> {{ item.qtd_clientes }} <br/>
                    </v-col>
                    <v-col cols="12" class="text-center bordered-col py-1">
                      <strong> % Var. Qtde de Clientes: </strong> <v-spacer/>
                      <span :class="corVariacao(item.var_qtd_clientes_aa)" class="font-weight-medium">{{ formataPercentual(item.var_qtd_clientes_aa) }}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogGrafico" fullscreen scrollable>
      <v-card v-if="indicadorSelecionado">
        <v-card-title class="primary white--text">
           {{ colunas.find((f) => f.valor === indicadorSelecionado).titulo }} - {{ dados.vendas ? dados.vendas.map(v => v.ano).join(', ') : ''}}
          <v-spacer/>
          <v-btn @click="dialogGrafico=false" icon color="white"><v-icon>mdi-close</v-icon> </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="px-6 pb-0">
          <GraficoLinhasMarketingTickets
              v-if="graficoSelecionado==='line'"
              :dataSeries="lineSeries"
              :key="JSON.stringify(lineSeries)"
              :categories="mesesNomes.map(item => item.titulo)"
              :distributed="false"
              :height="$vuetify.breakpoint.height-150"
              :money="(indicadorSelecionado === 'ticket_medio' || indicadorSelecionado === 'valor_vendas')"
              :porcent="(indicadorSelecionado === 'per_lucros')"
              :toolbar="true"
              :colors="['#023449','#efca00','#800017','#cd0000',
                '#E67E22','#4169E1','#008B45']"
          />

          <GraficoBarrasMarketingTickets
              v-if="graficoSelecionado==='bar'"
              :key="JSON.stringify(barSeries)"
              :dataSeries="barSeries"
              :categories="mesesNomes.map(item => item.titulo)"
              :height="$vuetify.breakpoint.height-180"
              :money="(indicadorSelecionado === 'ticket_medio' || indicadorSelecionado === 'valor_vendas')"
              :porcentagem="(indicadorSelecionado === 'per_lucros')"
              :distributed="false"
              :toolbar="true"
              :color="['#023449','#efca00','#800017','#cd0000',
                '#E67E22','#4169E1','#008B45']"
              :dataLabels="{
                                      position: 'top',
                                      orientation: 'horizontal',
                                      offsetY: -25,
                                  }"
          />
        </v-card-text>
        <v-card-actions class="justify-space-around my-1">
          <v-btn :class="{'active-btn2': indicadorSelecionado === 'qtd_vendas'}" :small="$vuetify.breakpoint.mdAndDown" color="primary" outlined @click="selecionarIndicador('qtd_vendas')" width="20%">
            <v-icon class="mr-1" :small="$vuetify.breakpoint.mdAndDown">mdi-counter</v-icon>
            Qtde de tickets
          </v-btn>

          <v-btn :class="{'active-btn2': indicadorSelecionado === 'valor_vendas'}" :small="$vuetify.breakpoint.mdAndDown" color="primary" outlined @click="selecionarIndicador('valor_vendas')" width="20%">
            <v-icon class="mr-1" :small="$vuetify.breakpoint.mdAndDown">mdi-cash</v-icon>
            Valor de vendas (R$)
          </v-btn>

          <v-btn :class="{'active-btn2': indicadorSelecionado === 'ticket_medio'}" :small="$vuetify.breakpoint.mdAndDown" color="primary" outlined @click="selecionarIndicador('ticket_medio')" width="16%">
            <v-icon class="mr-1" :small="$vuetify.breakpoint.mdAndDown">mdi-receipt</v-icon>
            Ticket médio
          </v-btn>

          <v-btn :class="{'active-btn2': indicadorSelecionado === 'qtd_clientes'}" :small="$vuetify.breakpoint.mdAndDown" color="primary" outlined @click="selecionarIndicador('qtd_clientes')" width="20%">
            <v-icon class="mr-1" :small="$vuetify.breakpoint.mdAndDown">mdi-account-group</v-icon>
            Qtde de clientes
          </v-btn>

          <v-btn :class="{'active-btn2': indicadorSelecionado === 'per_lucros'}" :small="$vuetify.breakpoint.mdAndDown" color="primary" outlined @click="selecionarIndicador('per_lucros')" width="20%">
            <v-icon class="mr-1" :small="$vuetify.breakpoint.mdAndDown">mdi-percent</v-icon>
            Margem bruta
          </v-btn>

<!--          <v-btn :class="{'active-btn2': indicadorSelecionado === 'media_ticket_clientes'}" :small="$vuetify.breakpoint.mdAndDown" color="primary" outlined @click="selecionarIndicador('media_ticket_clientes')" width="27%">-->
<!--            <v-icon class="mr-1" :small="$vuetify.breakpoint.mdAndDown">mdi-calculator</v-icon>-->
<!--            Média de tickets por cliente-->
<!--          </v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDetalhePrecarga" style="height: 70vh;"
              max-width="1224" :fullscreen="$vuetify.breakpoint.width<450" scrollable>
      <v-card class="primary border-dialog-card scroll-cores">
        <v-card-title class="pl-4 pr-3 white--text">
          <span>Pré Cargas - ({{ nomeEmpresaDialog }})</span>
          <v-spacer />
          <v-btn height="30" text x-small @click="dialogDetalhePrecarga = false" dark>
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-skeleton-loader
            class="pa-4"
            type="table-heading, list-item-two-line, table-tfoot"
            height="100%"
            v-if="carregando2"
        />
        <v-card-text class="pa-0" v-else>
          <v-data-table :height="detalheLote ? (detalheLote.length > 14 ? '70vh' : '100%') : '100%'" fixed-header
                        :items-per-page="40" mobile-breakpoint="0" :headers="[
              { text: 'Filial', value: 'empresa', class: 'pr-0 text-trucate' },
              { text: 'Pedido CISS Lote', value: 'pedido_compra', class: 'pr-0 text-no-wrap' },
              { text: 'Pedido Lote Conferido', value: 'idorcamento', align: 'center', class: 'pr-0 text-truncate' },
              { text: 'Pré Carga', value: 'idprecarga', align: 'center', class: 'pr-0 text-truncate' },
              { text: 'Nota', value: 'numnota', align: 'center', class: 'pr-0 text-truncate' },
              { text: 'Nota Entrada', value: 'notaentrada', align: 'center', class: 'pr-0 text-truncate' },

              { text: 'Dt. Ped. CISS Lote', value: 'dtpedido', align: 'center', class: 'pr-0 text-truncate' },
              { text: 'Dt. Ped. Lote Conferido', value: 'dtorcamento', align: 'center', class: 'pr-0 text-truncate' },
              { text: 'Dt. Pre-carga', value: 'dtprecarga', align: 'center', class: 'pr-0 text-truncate' },
              { text: 'Dt. Nota', value: 'dtnota', align: 'center', class: 'pr-0 text-truncate' },
              { text: 'Dt. Entrada', value: 'dtnotaentrada', align: 'center', class: 'pr-0 text-truncate' },

              { text: 'Pedido', value: 'pedido', class: 'pr-0 text-no-wrap' },
              { text: 'Separação', value: 'separacao', class: 'pr-0 text-no-wrap' },
              { text: 'Entrega', value: 'entrega', class: 'pr-0 text-no-wrap' },
              { text: 'Entrada', value: 'entrada', class: 'text-no-wrap' },


              { text: 'QTD Pre Carga', value: 'qtd_sku_pedido', class: 'text-no-wrap' },
              { text: 'QTD Nota', value: 'qtd_sku_nota', class: 'text-no-wrap' },
              { text: 'QTD Cancelado', value: 'qtd_sku_cancelado', class: 'text-no-wrap' },

              { text: 'Valor Orçamento', value: 'valor_orcamento', class: 'text-no-wrap' },
              { text: 'Valor Nota', value: 'valor_nota', class: 'text-no-wrap' },


            ]" :items="detalheLote" hide-default-footer>
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-left" nowrap> {{ item.empresa }} </td>
                <td class="text-center" nowrap> {{ item.pedido_compra }}</td>
                <td class="text-center" nowrap> {{ item.idorcamento }}</td>
                <td class="text-center" nowrap> {{ item.idprecarga }}</td>
                <td class="text-center" nowrap> {{ item.numnota }}</td>
                <td class="text-center" nowrap> {{ item.notaentrada }}</td>

                <td class="text-center" nowrap> {{ item.dtpedido }}</td>
                <td class="text-left" nowrap> {{ item.dtorcamento }}</td>
                <td class="text-left" nowrap> {{ item.dtprecarga }}</td>
                <td class="text-left" nowrap> {{ item.dtnota }}</td>
                <td class="text-left" nowrap> {{ item.dtnotaentrada }}</td>

                <td class="text-left" nowrap> {{ formatarTempo(item, 'pedido') }}</td>
                <td class="text-left" nowrap> {{ formatarTempo(item, 'separacao') }}</td>
                <td class="text-left" nowrap> {{ formatarTempo(item, 'entregas') }}</td>
                <td class="text-left" nowrap> {{ formatarTempo(item, 'entrada') }}</td>

                <td class="text-center" nowrap> {{ item.qtd_sku_pedido }}</td>
                <td class="text-center" nowrap> {{ item.qtd_sku_nota }}</td>
                <td class="text-center" nowrap> {{ item.qtd_sku_cancelado }}</td>

                <td class="text-center" nowrap> {{ item.valor_orcamento | formataDinheiro}}</td>
                <td class="text-center" nowrap> {{ item.valor_nota | formataDinheiro}}</td>

              </tr>
            </template>

            <template v-slot:foot>
              <tr class="font-weight-bold primary white--text">
                <td class="text-center" colspan="2"></td>
                <td class="text-center" >Totais</td>
                <td class="text-center" colspan="12" height="30px"></td>
                <td class="text-center" >{{ (detalheLote.map(v => v.qtd_sku_pedido).reduce((a,v) => a + v) || 0) }}</td>
                <td class="text-center" >{{ (detalheLote.map(v => v.qtd_sku_nota).reduce((a,v) => a + v) || 0) }}</td>
                <td class="text-center" >{{ (detalheLote.map(v => v.qtd_sku_cancelado).reduce((a,v) => a + v) || 0) }}</td>
                <td class="text-center" >{{ (detalheLote.map(v => v.valor_orcamento).reduce((a,v) => a + v) || 0) | formataDinheiro }}</td>
                <td class="text-center" >{{ (detalheLote.map(v => v.valor_nota).reduce((a,v) => a + v) || 0) | formataDinheiro }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>


    <!-- FILTROS -->
    <v-card elevation="1">
      <v-card-title>
        <v-row no-gutters>
          <v-col class="pr-2">
            <v-select
                :items="filtro_periodo"
                item-text="nome"
                item-value="tipo"
                label="Periodo"
                outlined
                dense
                v-model="busca.tipo_periodo"
                hide-details
                class="single-line-selection"
                @change="listar()"
                :disable-lookup="carregando"
            >
            </v-select>
          </v-col>

          <template v-if="busca.tipo_periodo === 'semana' && false">
            <v-col>
              <v-text-field
                  v-model="periodoFormatado"
                  label="Período (quinta a quarta)"
                  readonly
                  prepend-icon="mdi-chevron-left"
                  append-outer-icon="mdi-chevron-right"
                  @click:append-outer="avancarSemana"
                  @click:prepend="voltarSemana"
                  hide-details
                  outlined
                  dense
              >
                <template slot="prepend">
                  <v-btn class="primary mt-n2" icon dark elevation="0">
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                </template>
                <template slot="append-outer">
                  <v-btn class="primary mt-n2" icon dark elevation="0">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
          </template>

          <template v-if="busca.tipo_periodo === 'personalizado' && false">
            <!-- Data Inicial (quarta-feira) -->
            <v-col class="py-0 pr-2">
              <v-menu
                  ref="menuInicial"
                  v-model="menuInicial"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="dataInicialFormatada"
                      label="Data Inicial (quinta-feira)"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      hide-details
                      outlined
                      dense
                  ></v-text-field>
                </template>

                <v-card>
                  <v-date-picker
                      v-model="busca.dataInicial"
                      :allowed-dates="apenasQuintas"
                      locale="pt-br"
                      :events="getIntervaloDatas"
                      event-color="blue lighten-3"
                      scrollable
                      no-title
                  ></v-date-picker>
                </v-card>
              </v-menu>
            </v-col>

            <!-- Data Final (quinta-feira) -->
            <v-col class="py-0">
              <v-menu
                  ref="menuFinal"
                  v-model="menuFinal"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="dataFinalFormatada"
                      label="Data Final (quarta-feira)"
                      append-icon="mdi-calendar"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      hide-details
                      outlined
                      dense
                  ></v-text-field>
                </template>

                <v-card>
                  <v-date-picker
                      v-model="busca.dataFinal"
                      :allowed-dates="apenasQuartas"
                      locale="pt-br"
                      :events="getIntervaloDatas"
                      event-color="blue lighten-3"
                      scrollable
                      no-title
                  ></v-date-picker>
                </v-card>
              </v-menu>
            </v-col>
            <v-col cols="auto">
              <v-btn
                  :disabled="carregando"
                  class="mt-1 ml-3"
                  color="primary"
                  elevation="0"
                  fab
                  x-small
                  @click="listar()"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </template>

          <v-col v-if="false" class="px-1">
            <v-autocomplete
                :disabled="carregando"
                dense
                outlined
                v-model="busca.ano"
                @change="listar()"
                hide-details
                multiple
                label="Semana"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-title>
      <v-progress-linear small indeterminate absolute :active="carregando" />
    </v-card>

    <v-card class="mt-5" dark color="primary" elevation="1">
      <v-card-title class="px-5">
        <div style="max-width: 474px; width: 100%">
          Lotes Processados
        </div>
        <v-divider style="min-height:22px;" class="px-1" vertical />
        <v-menu offset-y :close-on-content-click="false" min-width="800" v-if="usuario.idusuario===8 && false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-show="graficoSelecionado === 'table-coluna'"
                light
                :loading="carregando"
                v-bind="attrs"
                v-on="on"
                small
                elevation="0"
            >
              <v-icon size="18" color="blue darken-2">mdi-filter-menu</v-icon>
            </v-btn>
          </template>
          <v-list dense class="pb-0">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 font-weight-bold mb-2">Colunas Visíveis</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-row no-gutters>
              <v-col v-for="(grupo, grupoIndex) in gruposColunas" :key="'grupo-'+grupoIndex" cols="12" sm="4">
                <v-list dense class="pt-0" style="border: rgba(160,174,192,0.15) solid 1px">
                  <v-list-item>
                    <v-list-item-action>
                      <v-switch
                          v-model="grupo.visible"
                          color="primary"
                          dense
                          hide-details
                          @change="toggleGrupo(grupoIndex)"
                      ></v-switch>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">{{ grupo.nome }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider/>

                  <!-- Colunas dentro do grupo com recuo -->
                  <v-list-item
                      v-for="(coluna, colunaIndex) in grupo.colunas"
                      :key="'coluna-'+grupoIndex+'-'+colunaIndex"
                      class="pl-6"
                  >
                    <v-list-item-action>
                      <v-switch
                          v-model="coluna.visible"
                          color="primary"
                          dense
                          hide-details
                          @change="toggleColuna(grupoIndex, colunaIndex)"
                      ></v-switch>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{ coluna.titulo }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-list>
        </v-menu>
        <template v-if="busca.tipo_periodo === 'semana'">
          <v-col class="py-0 pr-0">
            <v-text-field
                v-model="periodoFormatado"
                label="Período (quinta a quarta)"
                readonly
                hide-details
                dense
                class="mb-n4"
            >
              <template slot="prepend">
                <v-btn class="primary mt-n3" icon dark elevation="0" :disabled="carregando" @click="voltarSemana()">
                  <v-icon size="28">mdi-chevron-left</v-icon>
                </v-btn>
              </template>
              <template slot="append-outer">
                <v-btn class="primary mt-n3" icon dark elevation="0" :disabled="carregando" @click="avancarSemana()">
                  <v-icon size="28">mdi-chevron-right</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
        </template>

        <template v-if="busca.tipo_periodo === 'personalizado'">
          <!-- Data Inicial (quarta-feira) -->
          <v-col class="py-0 pl-6 pr-2">
            <v-menu
                ref="menuInicial"
                v-model="menuInicial"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dataInicialFormatada"
                    label="Data Inicial (quinta-feira)"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details
                    dense
                    class="mb-n2"
                ></v-text-field>
              </template>

              <v-card>
                <v-date-picker
                    v-model="busca.dataInicial"
                    :allowed-dates="apenasQuintas"
                    locale="pt-br"
                    :events="getIntervaloDatas"
                    event-color="blue lighten-3"
                    scrollable
                    no-title
                ></v-date-picker>
              </v-card>
            </v-menu>
          </v-col>

          <!-- Data Final (quinta-feira) -->
          <v-col class="py-0 pr-2">
            <v-menu
                ref="menuFinal"
                v-model="menuFinal"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dataFinalFormatada"
                    label="Data Final (quarta-feira)"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details
                    dense
                    class="mb-n2"
                ></v-text-field>
              </template>

              <v-card>
                <v-date-picker
                    v-model="busca.dataFinal"
                    :allowed-dates="apenasQuartas"
                    locale="pt-br"
                    :events="getIntervaloDatas"
                    event-color="blue lighten-3"
                    scrollable
                    no-title
                ></v-date-picker>
              </v-card>
            </v-menu>
          </v-col>
          <v-col v-if="true" cols="auto pa-0 mr-n1">
            <v-btn
                :disabled="carregando"
                color="primary"
                elevation="0"
                fab
                small
                @click="listar()"
            >
              <v-icon size="25">mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </template>
      </v-card-title>
      <v-divider/>

      <v-card-text class="pa-3">
        <v-skeleton-loader light type="table-tbody" v-if="carregandoSkeleton" />
        <v-simple-table light dense class="rounded-0 bordered-table" id="minha-tabela" v-else-if="!carregandoSkeleton">
          <template v-slot:default>
            <thead>
            <tr class="grey lighten-1">
              <th rowspan="2" colspan="1" class="px-2 text-center"><v-icon size="15" class="mr-2">mdi-dolly</v-icon> Lote </th>
              <th rowspan="2" colspan="1" class="px-2 text-center"><v-icon size="15" class="mr-2">mdi-domain</v-icon> Filial </th>
              <th v-show="gruposColunas[0].visible" colspan="7" class="px-2 py-1">
                <div class="d-flex align-center justify-space-between">
                  <!-- Espaço vazio para balancear a esquerda -->
                  <div style="width: 40px;"></div>

                  <!-- Conteúdo centralizado -->
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2">mdi-package</v-icon>
                    <span>Dados do Lote</span>
                  </div>

                  <!-- Botão para avançar para próxima coluna -->
                  <v-btn icon small @click="mostrarColuna(1)">
                    <v-icon color="primary">mdi-chevron-right</v-icon>
                  </v-btn>
                </div>
              </th>
              <th v-show="gruposColunas[1].visible" colspan="7" class="px-2 py-1">
                <div class="d-flex align-center justify-space-between">
                  <!-- Botão para voltar à coluna anterior -->
                  <v-btn icon small @click="mostrarColuna(0)">
                    <v-icon color="primary">mdi-chevron-left</v-icon>
                  </v-btn>

                  <!-- Conteúdo centralizado -->
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2">mdi-timer</v-icon>
                    <span>Tempo Médio de Execução por Etapa</span>
                  </div>

                  <!-- Botão para ir à próxima coluna -->
                  <v-btn icon small @click="mostrarColuna(2)">
                    <v-icon color="primary">mdi-chevron-right</v-icon>
                  </v-btn>
                </div>
              </th>
              <th v-show="gruposColunas[2].visible" colspan="7" class="px-2 py-1">
                <div class="d-flex align-center justify-space-between">
                  <!-- Botão para voltar à coluna anterior -->
                  <v-btn icon small @click="mostrarColuna(1)">
                    <v-icon color="primary">mdi-chevron-left</v-icon>
                  </v-btn>

                  <!-- Conteúdo centralizado -->
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2">mdi-alert</v-icon>
                    <span>Divergências</span>
                  </div>

                  <!-- Espaço fantasma para balancear a direita -->
                  <div style="width: 40px;"></div>
                </div>
              </th>
            </tr>
            <tr class="grey lighten-1">
              <th v-show="colunaVisivel('qtd_pedido')" class="px-2 text-center">Qtde Pedidos</th>
              <th v-show="colunaVisivel('qtd_sku')" class="px-2 text-center">Qtde Skus</th>
              <th v-show="colunaVisivel('valor_pedido')" class="px-2 text-center">Valor Total</th>
              <th v-show="colunaVisivel('qtd_sku_atendido')" class="px-2 text-center">Qtde Skus Atendidos</th>
              <th v-show="colunaVisivel('valor_pedido_atendido')" class="px-2 text-center">Valor Total Atendido</th>
              <th v-show="colunaVisivel('qtd_sku')" class="px-2 text-center">% Qtde Skus Atendidos</th>
              <th v-show="colunaVisivel('qtd_sku')" class="px-2 text-center">% Valor Atendido</th>

              <th v-show="colunaVisivel('tempo_pedido')" class="px-2 text-center">Pedido</th>
              <th v-show="colunaVisivel('tempo_separacao')" class="px-2 text-center">Separação</th>
              <th v-show="colunaVisivel('tempo_entrega')" colspan="2" class="px-2 text-center">Entrega</th>
              <th v-show="colunaVisivel('tempo_entrada')" colspan="2" class="px-2 text-center">Entrada</th>
              <th v-show="colunaVisivel('tempo_geral')" class="px-2 text-center">Geral</th>

              <th v-show="colunaVisivel('qtd_ocorrencia')" colspan="2" class="px-2 text-center">Qtde Ocorrências</th>
              <th v-show="colunaVisivel('valor_divergencia')" colspan="3" class="px-2 text-center">Valor Total</th>
              <th v-show="colunaVisivel('per_divergencia')" colspan="2" class="px-2 text-center"><v-icon small>mdi-percent-outline</v-icon></th>
            </tr>
            </thead>

            <tbody>
            <tr
                v-for="(linha, index) in linhasTabela"
                :key="`linha-${index}`"
                @click="linha.tipo === 'loja' && linha.loja.qtd_pedido > 0 && (listarPrecargas(linha.loja.lote, linha.loja.idempresa, linha.loja.empresa), dialogDetalhePrecarga = true)"
                @mouseover="linha.tipo === 'loja' && (hoveredLote = linha.loteIndex)"
                @mouseleave="linha.tipo === 'loja' && (hoveredLote = null)"
                :class="{ 'subtotal-row': linha.tipo === 'subtotal' }"
                style="cursor: pointer;"
            >
              <!-- LOJA -->
              <template v-if="linha.tipo === 'loja'">
                <!-- Coluna de LOTE com rowspan -->
                <td
                    v-if="linha.exibirLote"
                    :rowspan="linha.rowspan"
                    width="230px"
                    style="height: 150px !important;"
                    :class="{ 'hover-lote': hoveredLote === linha.loteIndex }"
                >
                  <div class="info-item"><strong>Sequência:</strong> {{ linha.lote.lote }}º</div>
                  <div class="info-item"><strong>Pedido:</strong> {{ linha.lote.dia_pedido }}</div>
                  <div class="info-item"><strong>Separação:</strong> {{ linha.lote.dia_separacao }}</div>
                  <div class="info-item"><strong>Carregamento:</strong> {{ linha.lote.dia_carregamento }}</div>
                </td>

                <td width="260px">{{ linha.loja.empresa }}</td>
                <td v-show="colunaVisivel('qtd_pedido')" class="text-center">{{ linha.loja.qtd_pedido || 0 }}</td>
                <td v-show="colunaVisivel('qtd_sku')" class="text-center">{{ linha.loja.qtd_sku || 0 }}</td>
                <td v-show="colunaVisivel('valor_pedido')" class="text-center">{{ (linha.loja.total_valor || 0) | formataDinheiro }}</td>
                <td v-show="colunaVisivel('qtd_sku_atendido')" class="text-center">{{ linha.loja.qtd_pedido_atendido || 0 }}</td>
                <td v-show="colunaVisivel('valor_pedido_atendido')" class="text-center">{{ (linha.loja.valor_atendido || 0) | formataDinheiro }}</td>
                <td v-show="colunaVisivel('qtd_sku')" class="text-center">{{ linha.loja.perc_qtdsku_atendido || 0 }}%</td>
                <td v-show="colunaVisivel('qtd_sku')" class="text-center">{{ linha.loja.perc_valor_atendido || 0 }}%</td>

                <td v-show="colunaVisivel('tempo_pedido')" class="text-center">{{ formatarTempo(linha.loja, 'pedido') }}</td>
                <td v-show="colunaVisivel('tempo_separacao')" class="text-center">{{ formatarTempo(linha.loja, 'separacao') }}</td>
                <td v-show="colunaVisivel('tempo_entrega')" colspan="2" class="text-center">{{ formatarTempo(linha.loja, 'entregas') }}</td>
                <td v-show="colunaVisivel('tempo_entrada')" colspan="2" class="text-center">{{ formatarTempo(linha.loja, 'entrada') }}</td>
                <td v-show="colunaVisivel('tempo_geral')" class="text-center">{{ formatarTempo(linha.loja, 'geral') }}</td>

                <td v-show="colunaVisivel('qtd_ocorrencia')" colspan="2"  class="text-center">{{ formatarTempo(linha.loja, 'pedido') }}</td>
                <td v-show="colunaVisivel('valor_divergencia')" colspan="3" class="text-center">{{ (linha.loja.valor || 0) | formataDinheiro }}</td>
                <td v-show="colunaVisivel('per_divergencia')" colspan="2" class="text-center">{{ linha.loja.valor || 0 }} %</td>
              </template>

              <!-- SUBTOTAL -->
              <template v-else-if="linha.tipo === 'subtotal'" class="subtotal-row">
                <td colspan="2" class="text-right subtotal-row">Subtotal do Lote {{ linha.lote.lote }}°:</td>
                <td v-show="colunaVisivel('qtd_pedido')" class="text-center subtotal-row">
                  {{ somarPorLote(linha.lote.lojas, 'qtd_pedido') }}
                </td>
                <td v-show="colunaVisivel('qtd_sku')" class="text-center subtotal-row">
                  {{ somarPorLote(linha.lote.lojas, 'qtd_sku') }}
                </td>
                <td v-show="colunaVisivel('valor_pedido')" class="text-center subtotal-row">
                  {{ somarPorLote(linha.lote.lojas, 'total_valor') | formataDinheiro }}
                </td>
                <td v-show="colunaVisivel('qtd_sku_atendido')" class="text-center subtotal-row">
                  {{ somarPorLote(linha.lote.lojas, 'qtd_pedido_atendido') }}
                </td>
                <td v-show="colunaVisivel('valor_pedido_atendido')" class="text-center subtotal-row">
                  {{ somarPorLote(linha.lote.lojas, 'valor_atendido') | formataDinheiro }}
                </td>
                <td colspan="2"  class="subtotal-row" v-show="colunaVisivel('valor_pedido_atendido')"></td>

                <td v-show="colunaVisivel('tempo_pedido')" class="text-center subtotal-row"></td>
                <td v-show="colunaVisivel('tempo_separacao')" class="text-center subtotal-row"></td>
                <td v-show="colunaVisivel('tempo_entrega')" colspan="2" class="text-center subtotal-row"></td>
                <td v-show="colunaVisivel('tempo_entrada')" colspan="2" class="text-center subtotal-row"></td>
                <td v-show="colunaVisivel('tempo_geral')" class="text-center subtotal-row"></td>

                <td v-show="colunaVisivel('qtd_ocorrencia')" colspan="2" class="text-center subtotal-row"></td>
                <td v-show="colunaVisivel('valor_divergencia')" colspan="3" class="text-center subtotal-row"></td>
                <td v-show="colunaVisivel('per_divergencia')" colspan="2" class="text-center subtotal-row"></td>

              </template>
            </tr>
            <!-- Total geral -->
            <tr class="bg-dark text-white font-weight-bold">
              <td class="text-end white--text total-row" colspan="2">Total Geral:</td>
              <td v-show="colunaVisivel('qtd_pedido')" class="white--text text-center total-row">{{ totalGeral.qtd_pedido }}</td>
              <td v-show="colunaVisivel('qtd_sku')" class="white--text text-center total-row">{{ totalGeral.qtd_sku }}</td>
              <td v-show="colunaVisivel('valor_pedido')" class="white--text text-center total-row">{{ totalGeral.valor | formataDinheiro }}</td>
              <td v-show="colunaVisivel('qtd_sku_atendido')" class="white--text text-center total-row">{{ totalGeral.qtd_pedido_atendido }}</td>
              <td v-show="colunaVisivel('valor_pedido_atendido')" class="white--text text-center total-row">{{ totalGeral.valor_atendido | formataDinheiro }}</td>
              <td colspan="2" v-show="colunaVisivel('valor_pedido_atendido')" class="total-row"></td>

              <td v-show="colunaVisivel('tempo_pedido')" class="text-center total-row"></td>
              <td v-show="colunaVisivel('tempo_separacao')" class="text-center total-row"></td>
              <td v-show="colunaVisivel('tempo_entrega')" colspan="2" class="text-center total-row"></td>
              <td v-show="colunaVisivel('tempo_entrada')" colspan="2" class="text-center total-row"></td>
              <td v-show="colunaVisivel('tempo_geral')" class="text-center total-row"></td>

              <td v-show="colunaVisivel('qtd_ocorrencia')" colspan="2" class="text-center total-row"></td>
              <td v-show="colunaVisivel('valor_divergencia')" colspan="3" class="text-center total-row"></td>
              <td v-show="colunaVisivel('per_divergencia')" colspan="2" class="text-center total-row"></td>
            </tr>
            </tbody>

          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>


    <!-- VISAO PC -->
    <template v-if="$vuetify.breakpoint.mdAndUp && false">


      <v-card v-if="false" elevation="1">
        <v-card-title>
          <v-row no-gutters>
            <v-col class="pr-2">
              <v-select
                  :items="filiaisFiltro"
                  item-text="filial"
                  item-value="idfilial"
                  label="Filial"
                  outlined
                  dense
                  v-model="busca.idfiliais"
                  hide-details
                  multiple
                  class="single-line-selection"
                  @change="listar()"
              >
                <template v-slot:selection="{ item, index }">
                  <template v-if="selectAllChecked">
                    <span v-if="index === 0">Todas</span>
                  </template>
                  <template v-else>
                    <span v-if="index === 0" class="mr-1">{{ item.filial }}</span>
                    <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ busca.idfiliais.length - 1 }})
                  </span>
                  </template>
                </template>

                <template #prepend-item>
                  <v-list-item
                      class="pr-0"
                      dense
                      :style="{
                      backgroundColor: selectAllChecked ? '#D0D6D9' : 'transparent'
                    }"
                  >
                    <v-list-item-action>
                      <v-checkbox v-model="selectAllChecked" @click.stop="toggleSelectAll('CHECKBOX')"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content @click="toggleSelectAll('LABEL')">
                      <label class="text-subtitle-2">Todas</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
            <v-col class="px-1">
              <v-autocomplete
                  :disabled="carregando"
                  dense
                  outlined
                  :items="anos"
                  v-model="busca.ano"
                  @change="listar()"
                  hide-details
                  multiple
                  label="Ano"
              >
              </v-autocomplete>
            </v-col>

            <!--          <v-col cols="auto">-->
            <!--            <v-btn-->
            <!--                :disabled="carregando"-->
            <!--                class="mt-1 ml-2"-->
            <!--                color="primary"-->
            <!--                elevation="0"-->
            <!--                fab-->
            <!--                x-small-->
            <!--                @click="listar()"-->
            <!--            >-->
            <!--              <v-icon>mdi-magnify</v-icon>-->
            <!--            </v-btn>-->
            <!--          </v-col>-->
          </v-row>
        </v-card-title>
      </v-card>

      <v-row v-if="false" class="pa-2 mt-1">
            <v-col class="pa-1">
              <CardDashboard :loading="carregando" title="Valor por Avaria" :color="primary">
                <template v-if="false">
                </template>
                <template v-else>
                  {{ 0 | formataDinheiro }} /
                  {{ 0 }} %
                </template>
              </CardDashboard>
            </v-col>
        <v-col class="pa-1">
          <CardDashboard :loading="carregando" title="Valor por Vencimento" :color="primary">
            <template v-if="false">
            </template>
            <template v-else>
              {{ 0 | formataDinheiro }} /
              {{ 0 }} %
            </template>
          </CardDashboard>
        </v-col>
        <v-col class="pa-1">
          <CardDashboard :loading="carregando" title="Valor com Má qualidade" :color="primary">
            <template v-if="false">
            </template>
            <template v-else>
              {{ 0 | formataDinheiro }} /
              {{ 0 }} %
            </template>
          </CardDashboard>
        </v-col>
        <v-col class="pa-1">
          <CardDashboard :loading="carregando" title="Valor total de ocorrências" :color="primary">
            <template v-if="false">
            </template>
            <template v-else>
              {{ 0 | formataDinheiro }} /
              {{ 0 }} %
            </template>
          </CardDashboard>
        </v-col>
          </v-row>

      <!-- CARD MESES -->


      <v-card v-if="false" class="mt-5" dark color="primary" elevation="1">
        <v-card-title class="px-3">
          <v-row>
            <v-col>
              Divergência de Remessas
            </v-col>
            <v-col class="py-sm-0 pt-0 pb-3 justify-center align-center align-content-center" cols="12" xl="auto" lg="auto" md="auto" sm="auto">
              <!--              <v-menu offset-y :close-on-content-click="false" min-width="800">-->
              <!--                <template v-slot:activator="{ on, attrs }">-->
              <!--                  <v-btn-->
              <!--                      v-show="graficoSelecionado === 'table-coluna'"-->
              <!--                      light-->
              <!--                      :loading="carregando"-->
              <!--                      v-bind="attrs"-->
              <!--                      v-on="on"-->
              <!--                      small-->
              <!--                      elevation="0"-->
              <!--                  >-->
              <!--                    <v-icon size="18" color="blue darken-2">mdi-filter-menu</v-icon>-->
              <!--                  </v-btn>-->
              <!--                </template>-->
              <!--                <v-list dense class="pb-0">-->
              <!--                  <v-list-item>-->
              <!--                    <v-list-item-content>-->
              <!--                      <v-list-item-title class="subtitle-1 font-weight-bold mb-2">Colunas Visíveis</v-list-item-title>-->
              <!--                    </v-list-item-content>-->
              <!--                  </v-list-item>-->
              <!--                  <v-divider></v-divider>-->
              <!--                  <v-row no-gutters>-->
              <!--                    <v-col v-for="(grupo, grupoIndex) in gruposColunas" :key="'grupo-'+grupoIndex" cols="12" sm="4">-->
              <!--                      <v-list dense class="pt-0" style="border: rgba(160,174,192,0.15) solid 1px">-->
              <!--                        <v-list-item>-->
              <!--                          <v-list-item-action>-->
              <!--                            <v-switch-->
              <!--                                v-model="grupo.visible"-->
              <!--                                color="primary"-->
              <!--                                dense-->
              <!--                                hide-details-->
              <!--                                @change="toggleGrupo(grupoIndex)"-->
              <!--                            ></v-switch>-->
              <!--                          </v-list-item-action>-->
              <!--                          <v-list-item-content>-->
              <!--                            <v-list-item-title class="font-weight-medium">{{ grupo.nome }}</v-list-item-title>-->
              <!--                          </v-list-item-content>-->
              <!--                        </v-list-item>-->
              <!--                        <v-divider/>-->

              <!--                        &lt;!&ndash; Colunas dentro do grupo com recuo &ndash;&gt;-->
              <!--                        <v-list-item-->
              <!--                            v-for="(coluna, colunaIndex) in grupo.colunas"-->
              <!--                            :key="'coluna-'+grupoIndex+'-'+colunaIndex"-->
              <!--                            class="pl-6"-->
              <!--                        >-->
              <!--                          <v-list-item-action>-->
              <!--                            <v-switch-->
              <!--                                v-model="coluna.visible"-->
              <!--                                color="primary"-->
              <!--                                dense-->
              <!--                                hide-details-->
              <!--                                @change="toggleColuna(grupoIndex, colunaIndex)"-->
              <!--                            ></v-switch>-->
              <!--                          </v-list-item-action>-->
              <!--                          <v-list-item-content>-->
              <!--                            <v-list-item-title>{{ coluna.titulo }}</v-list-item-title>-->
              <!--                          </v-list-item-content>-->
              <!--                        </v-list-item>-->
              <!--                      </v-list>-->
              <!--                    </v-col>-->
              <!--                  </v-row>-->
              <!--                </v-list>-->
              <!--              </v-menu>-->

<!--              <v-btn-->
<!--                  light-->
<!--                  :loading="carregando"-->
<!--                  @click="selecionarGrafico('table-coluna')"-->
<!--                  :class="{'active-btn': graficoSelecionado === 'table-coluna'}"-->
<!--                  small-->
<!--                  elevation="0"-->
<!--                  class="ml-2"-->
<!--              >-->
<!--                <v-icon>mdi-table</v-icon>-->
<!--              </v-btn>-->

<!--              <v-divider style="min-height:22px;" class="px-1" vertical />-->

<!--              <v-btn-->
<!--                  light-->
<!--                  :loading="carregando"-->
<!--                  @click="selecionarGrafico('line')"-->
<!--                  :class="{'active-btn': graficoSelecionado === 'line'}"-->
<!--                  small-->
<!--                  elevation="0"-->
<!--                  class="ml-2"-->
<!--              >-->
<!--                <v-icon>mdi-calendar-month</v-icon>-->
<!--              </v-btn>-->

            </v-col>
          </v-row>
        </v-card-title>
        <v-progress-linear small indeterminate absolute :active="carregando" />
        <v-divider/>

        <v-card-text class="pa-3">
          <v-skeleton-loader v-if="carregandoSkeleton" type="table-tbody" />

          <v-simple-table v-else-if="graficoSelecionado==='table-coluna' && dados" light dense class="rounded-0 bordered-table" id="minha-tabela">
            <template v-slot:default>
              <thead>
              <tr class="grey lighten-1">
                <th rowspan="2" class="text-left px-2" width="14%" style="height: 38px !important;">
                  <div
                      class="d-flex align-center justify-space-between w-100"
                      @click="toggleAll"
                      :style="{ cursor: 'pointer' }"
                  >
                    <span>Período</span>
                    <v-icon>{{ allCollapsed ? 'mdi-chevron-double-right' : 'mdi-chevron-double-down' }}</v-icon>
                  </div>
                </th>
                <th colspan="2" class="px-2 text-center"><v-icon size="15" class="mr-2">mdi-package-variant-minus</v-icon> Faltas</th>
                <th colspan="2" class="px-2 text-center"><v-icon size="15" class="mr-2">mdi-package-variant-plus</v-icon> Sobras</th>
                <th colspan="3" class="px-2 text-center"><v-icon size="15" class="mr-2">mdi-truck-alert-outline</v-icon> Total Divergência</th>
              </tr>
              <tr class="grey lighten-1">
                <th class="px-2 text-center">Quantidade</th>
                <th class="px-2 text-center">Valor</th>
                <th class="px-2 text-center">Quantidade</th>
                <th class="px-2 text-center">Valor</th>
                <th class="px-2 text-center">Quantidade</th>
                <th class="px-2 text-center">Valor</th>
                <th class="px-2 text-center"><v-icon small>mdi-percent-outline</v-icon></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(mes, index) in dias" :key="`${index}`" v-show="!collapsedState[i]" class="fade-transition">
                <td class="px-2 text-center">{{ mes.dataCompleta | formataData }}</td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
              </tr>
              </tbody>
              <!--              <tfoot>-->
              <!--              <tr class="font-weight-bold grey lighten-4">-->
              <!--                <td class="pa-2">Total Geral</td>-->

              <!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_vendas_aa')">{{ formataNumero(dados.total_geral_qtd_vendas_aa) }}</td>-->
              <!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_vendas')">{{ formataNumero(dados.total_geral_qtd_vendas) }}</td>-->
              <!--                <td :class="corVariacao(dados.total_geral_var_qtd_vendas)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_qtd_vendas')">-->
              <!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dados.total_geral_var_qtd_vendas>0">mdi-arrow-up-bold</v-icon>-->
              <!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dados.total_geral_var_qtd_vendas<0">mdi-arrow-down-bold</v-icon>-->
              <!--                  <div class="text-right" style="min-width: 60px;">-->
              <!--                    {{ formataPercentual(dados.total_geral_var_qtd_vendas) }} %-->
              <!--                  </div>-->
              <!--                </td>-->

              <!--                <td class="px-2 text-center" v-show="colunaVisivel('valor_vendas_aa')">{{ dados.total_geral_valor_vendas_aa | formataDinheiro }}</td>-->
              <!--                <td class="px-2 text-center" v-show="colunaVisivel('valor_vendas')">{{ dados.total_geral_valor_vendas | formataDinheiro }}</td>-->
              <!--                <td :class="corVariacao(dados.total_geral_var_valor_vendas)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_valor_vendas')">-->
              <!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dados.total_geral_var_valor_vendas>0">mdi-arrow-up-bold</v-icon>-->
              <!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dados.total_geral_var_valor_vendas<0">mdi-arrow-down-bold</v-icon>-->
              <!--                  <div class="text-right" style="min-width: 60px;">-->
              <!--                    {{ formataPercentual(dados.total_geral_var_valor_vendas) }} %-->
              <!--                  </div>-->
              <!--                </td>-->

              <!--                <td class="px-2 text-center" v-show="colunaVisivel('ticket_medio_aa')">{{ dados.total_geral_ticket_medio_aa | formataDinheiro }}</td>-->
              <!--                <td class="px-2 text-center" v-show="colunaVisivel('ticket_medio')">{{ dados.total_geral_ticket_medio | formataDinheiro }}</td>-->
              <!--                <td :class="corVariacao(dados.total_geral_var_ticket_medio)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_ticket_medio')">-->
              <!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dados.total_geral_var_ticket_medio>0">mdi-arrow-up-bold</v-icon>-->
              <!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dados.total_geral_var_ticket_medio<0">mdi-arrow-down-bold</v-icon>-->
              <!--                  <div class="text-right" style="min-width: 60px;">-->
              <!--                    {{ formataPercentual(dados.total_geral_var_ticket_medio) }} %-->
              <!--                  </div>-->
              <!--                </td>-->

              <!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_clientes_aa')">{{ formataNumero(dados.total_geral_qtd_clientes_aa) }}</td>-->
              <!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_clientes')">{{ formataNumero(dados.total_geral_qtd_clientes) }}</td>-->
              <!--                <td :class="corVariacao(dados.total_geral_var_qtd_clientes)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_qtd_clientes')">-->
              <!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dados.total_geral_var_qtd_clientes>0">mdi-arrow-up-bold</v-icon>-->
              <!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dados.total_geral_var_qtd_clientes<0">mdi-arrow-down-bold</v-icon>-->
              <!--                  <div class="text-right" style="min-width: 60px;">-->
              <!--                    {{ formataPercentual(dados.total_geral_var_qtd_clientes) }} %-->
              <!--                  </div>-->
              <!--                </td>-->

              <!--                <td class="px-2 text-center" v-show="colunaVisivel('per_lucros_aa')">{{ dados.total_geral_per_lucro_aa ? dados.total_geral_per_lucro_aa.toFixed(2) + ' %' : '-' }}</td>-->
              <!--                <td class="px-2 text-center" v-show="colunaVisivel('per_lucros')">{{ dados.total_geral_per_lucro ? dados.total_geral_per_lucro.toFixed(2) + ' %' : '-' }}</td>-->
              <!--                <td :class="corVariacao(dados.total_geral_var_per_lucro)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_per_lucros')">-->
              <!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dados.total_geral_var_per_lucro>0">mdi-arrow-up-bold</v-icon>-->
              <!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dados.total_geral_var_per_lucro<0">mdi-arrow-down-bold</v-icon>-->
              <!--                  <div class="text-right" style="min-width: 60px;">-->
              <!--                    {{ formataPercentual(dados.total_geral_var_per_lucro) }} %-->
              <!--                  </div>-->
              <!--                </td>-->
              <!--&lt;!&ndash;                <td class="px-2 text-center" v-show="colunaVisivel('media_ticket_clientes_aa')">{{ dados.total_geral_media_ticket_clientes_aa ? dados.total_geral_media_ticket_clientes_aa.toFixed(2) : '-' }}</td>&ndash;&gt;-->
              <!--&lt;!&ndash;                <td class="px-2 text-center" v-show="colunaVisivel('media_ticket_clientes')">{{ dados.total_geral_media_ticket_clientes ? dados.total_geral_media_ticket_clientes.toFixed(2) : '-' }}</td>&ndash;&gt;-->
              <!--&lt;!&ndash;                <td :class="corVariacao(dados.total_geral_var_media_ticket_clientes)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_media_ticket_clientes')">&ndash;&gt;-->
              <!--&lt;!&ndash;                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dados.total_geral_var_media_ticket_clientes>0">mdi-arrow-up-bold</v-icon>&ndash;&gt;-->
              <!--&lt;!&ndash;                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dados.total_geral_var_media_ticket_clientes<0">mdi-arrow-down-bold</v-icon>&ndash;&gt;-->
              <!--&lt;!&ndash;                  <div class="text-right" style="min-width: 60px;">&ndash;&gt;-->
              <!--&lt;!&ndash;                    {{ formataPercentual(dados.total_geral_var_media_ticket_clientes) }}&ndash;&gt;-->
              <!--&lt;!&ndash;                  </div>&ndash;&gt;-->
              <!--&lt;!&ndash;                </td>&ndash;&gt;-->
              <!--              </tr>-->
              <!--              </tfoot>-->
            </template>
          </v-simple-table>

          <!-- SELEÇÃO DO INDICADOR -->
          <v-card class="align-content-center align-center" light v-else max-height="500px">
            <v-sheet height="500">
              <v-calendar
                  ref="calendar"
              ></v-calendar>
            </v-sheet>
          </v-card>
        </v-card-text>
        <v-progress-linear indeterminate absolute :active="carregando" />
      </v-card>

      <v-card v-if="false" class="mt-5" dark color="primary" elevation="1">
        <v-card-title class="px-3">
          <v-row>
            <v-col>
              Relação de Entregas - {{ dados.vendas ? dados.vendas.map(v => v.ano).join(', ') : ''}}
            </v-col>
            <v-col class="py-sm-0 pt-0 pb-3 justify-center align-center align-content-center" cols="12" xl="auto" lg="auto" md="auto" sm="auto">
<!--              <v-menu offset-y :close-on-content-click="false" min-width="800">-->
<!--                <template v-slot:activator="{ on, attrs }">-->
<!--                  <v-btn-->
<!--                      v-show="graficoSelecionado === 'table-coluna'"-->
<!--                      light-->
<!--                      :loading="carregando"-->
<!--                      v-bind="attrs"-->
<!--                      v-on="on"-->
<!--                      small-->
<!--                      elevation="0"-->
<!--                  >-->
<!--                    <v-icon size="18" color="blue darken-2">mdi-filter-menu</v-icon>-->
<!--                  </v-btn>-->
<!--                </template>-->
<!--                <v-list dense class="pb-0">-->
<!--                  <v-list-item>-->
<!--                    <v-list-item-content>-->
<!--                      <v-list-item-title class="subtitle-1 font-weight-bold mb-2">Colunas Visíveis</v-list-item-title>-->
<!--                    </v-list-item-content>-->
<!--                  </v-list-item>-->
<!--                  <v-divider></v-divider>-->
<!--                  <v-row no-gutters>-->
<!--                    <v-col v-for="(grupo, grupoIndex) in gruposColunas" :key="'grupo-'+grupoIndex" cols="12" sm="4">-->
<!--                      <v-list dense class="pt-0" style="border: rgba(160,174,192,0.15) solid 1px">-->
<!--                        <v-list-item>-->
<!--                          <v-list-item-action>-->
<!--                            <v-switch-->
<!--                                v-model="grupo.visible"-->
<!--                                color="primary"-->
<!--                                dense-->
<!--                                hide-details-->
<!--                                @change="toggleGrupo(grupoIndex)"-->
<!--                            ></v-switch>-->
<!--                          </v-list-item-action>-->
<!--                          <v-list-item-content>-->
<!--                            <v-list-item-title class="font-weight-medium">{{ grupo.nome }}</v-list-item-title>-->
<!--                          </v-list-item-content>-->
<!--                        </v-list-item>-->
<!--                        <v-divider/>-->

<!--                        &lt;!&ndash; Colunas dentro do grupo com recuo &ndash;&gt;-->
<!--                        <v-list-item-->
<!--                            v-for="(coluna, colunaIndex) in grupo.colunas"-->
<!--                            :key="'coluna-'+grupoIndex+'-'+colunaIndex"-->
<!--                            class="pl-6"-->
<!--                        >-->
<!--                          <v-list-item-action>-->
<!--                            <v-switch-->
<!--                                v-model="coluna.visible"-->
<!--                                color="primary"-->
<!--                                dense-->
<!--                                hide-details-->
<!--                                @change="toggleColuna(grupoIndex, colunaIndex)"-->
<!--                            ></v-switch>-->
<!--                          </v-list-item-action>-->
<!--                          <v-list-item-content>-->
<!--                            <v-list-item-title>{{ coluna.titulo }}</v-list-item-title>-->
<!--                          </v-list-item-content>-->
<!--                        </v-list-item>-->
<!--                      </v-list>-->
<!--                    </v-col>-->
<!--                  </v-row>-->
<!--                </v-list>-->
<!--              </v-menu>-->

              <v-btn
                  light
                  :loading="carregando"
                  @click="selecionarGrafico('table-coluna')"
                  :class="{'active-btn': graficoSelecionado === 'table-coluna'}"
                  small
                  elevation="0"
                  class="ml-2"
              >
                <v-icon>mdi-table</v-icon>
              </v-btn>

              <v-divider style="min-height:22px;" class="px-1" vertical />

              <v-btn
                  light
                  :loading="carregando"
                  @click="selecionarGrafico('line')"
                  :class="{'active-btn': graficoSelecionado === 'line'}"
                  small
                  elevation="0"
                  class="ml-2"
              >
                <v-icon>mdi-calendar-month</v-icon>
              </v-btn>

            </v-col>
          </v-row>
        </v-card-title>
        <v-progress-linear small indeterminate absolute :active="carregando" />
        <v-divider/>

        <v-card-text class="pa-3">
          <v-skeleton-loader v-if="carregandoSkeleton" type="table-tbody" />

          <v-simple-table v-else-if="graficoSelecionado==='table-coluna' && dados" light dense class="rounded-0 bordered-table" id="minha-tabela">
            <template v-slot:default>
              <thead>
              <tr class="grey lighten-1">
                <th rowspan="2" class="text-left px-2" width="14%" style="height: 38px !important;">
                  <div
                      class="d-flex align-center justify-space-between w-100"
                      @click="toggleAll"
                      :style="{ cursor: 'pointer' }"
                  >
                    <span>Período</span>
                    <v-icon>{{ allCollapsed ? 'mdi-chevron-double-right' : 'mdi-chevron-double-down' }}</v-icon>
                  </div>
                </th>
                <th colspan="3" class="px-2 text-center">Pedidos Entregues</th>
                <th colspan="3" class="px-2 text-center">Pedidos a Entregar</th>
                <th colspan="4" class="px-2 text-center">Média de Entregas</th>
              </tr>
              <tr class="grey lighten-1">
                <th class="px-2 text-center"><v-icon size="15" class="mr-2">mdi-truck-check-outline</v-icon>Total</th>
                <th class="px-2 text-center"><v-icon size="15" class="mr-2">mdi-clock-check-outline</v-icon>Em dia</th>
                <th class="px-2 text-center"><v-icon size="15" class="mr-2">mdi-clock-alert-outline</v-icon>Em atraso</th>
<!--                <th class="px-2 text-center"><v-icon size="15" class="mr-2">mdi-keyboard-return</v-icon>Devolvidos</th>-->
<!--                <th class="px-2 text-center"><v-icon size="15" class="mr-2">mdi-cube-off-outline</v-icon>Cortados</th>-->
                <th class="px-2 text-center"><v-icon size="15" class="mr-2">mdi-truck-alert-outline</v-icon>Total</th>
                <th class="px-2 text-center"><v-icon size="15" class="mr-2">mdi-clock-check-outline</v-icon>Em dia</th>
                <th class="px-2 text-center"><v-icon size="15" class="mr-2">mdi-clock-alert-outline</v-icon>Em atraso</th>
                <th class="px-2 text-center">1 dia</th>
                <th class="px-2 text-center">7 dias</th>
                <th class="px-2 text-center">15 dias</th>
                <th class="px-2 text-center">30 dias</th>
              </tr>
              </thead>
<!--              <tbody v-for="(dadosAno, i) in dados.vendas" :key="i" v-if="false">-->
<!--              <tr v-for="(mes, index) in mesesNomes" :key="`${i}-${index}`" v-show="!collapsedState[i]" class="fade-transition">-->
<!--                <td class="px-0 text-caption font-weight-medium">-->
<!--                  <v-hover v-slot="{ hover }">-->
<!--                    <div-->
<!--                        v-if="dadosAno.qtd_vendas[mes.valor]"-->
<!--                        class="d-flex align-center justify-space-between w-100 pa-2"-->
<!--                        :style="{ backgroundColor: hover ? '#E0E0E0' : 'transparent', cursor: 'pointer' }"-->
<!--                        @click="detalharMes(dadosAno.ano, mes)"-->
<!--                    >-->
<!--                      <span>{{ mes.apelido }}/{{dadosAno.ano}}</span>-->
<!--                      <v-icon size="21" v-if="hover">mdi-magnify-plus-outline</v-icon>-->
<!--                      <v-icon size="20" v-else>mdi-magnify-plus-outline</v-icon>-->
<!--                    </div>-->
<!--                    <div v-else class="pa-2">-->
<!--                      <span>{{ mes.apelido }}/{{dadosAno.ano}}</span>-->
<!--                    </div>-->
<!--                  </v-hover>-->
<!--                </td>-->
<!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_vendas_aa')">{{ formataNumero(dadosAno.qtd_vendas_aa[mes.valor]) }}</td>-->
<!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_vendas')">{{ formataNumero(dadosAno.qtd_vendas[mes.valor]) }}</td>-->
<!--                <td :class="corVariacao(dadosAno.var_qtd_vendas[mes.valor])" class="px-5 align-center font-weight-medium" nowrap v-show="colunaVisivel('var_qtd_vendas')">-->
<!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dadosAno.var_qtd_vendas[mes.valor]>0">mdi-arrow-up-bold</v-icon>-->
<!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dadosAno.var_qtd_vendas[mes.valor]<0">mdi-arrow-down-bold</v-icon>-->
<!--                  <div class="text-right" style="min-width: 60px;">-->
<!--                    {{ formataPercentual( dadosAno.var_qtd_vendas[mes.valor], dataValida(dadosAno.ano, mes.id)) }} %-->
<!--                  </div>-->
<!--                </td>-->

<!--                <td class="px-2 text-center" v-show="colunaVisivel('valor_vendas_aa')">{{ (dadosAno.valor_vendas_aa[mes.valor] ? formataDinheiro(dadosAno.valor_vendas_aa[mes.valor]) : '-')  }}</td>-->
<!--                <td class="px-2 text-center" v-show="colunaVisivel('valor_vendas')">{{ (dadosAno.valor_vendas[mes.valor] ? formataDinheiro(dadosAno.valor_vendas[mes.valor]) : '-')  }}</td>-->
<!--                <td :class="corVariacao(dadosAno.var_valor_vendas[mes.valor])" class="px-5 text-center font-weight-medium" nowrap v-show="colunaVisivel('var_valor_vendas')">-->
<!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dadosAno.var_valor_vendas[mes.valor]>0">mdi-arrow-up-bold</v-icon>-->
<!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dadosAno.var_valor_vendas[mes.valor]<0">mdi-arrow-down-bold</v-icon>-->
<!--                  <div class="text-right" style="min-width: 60px;">-->
<!--                    {{ formataPercentual(dadosAno.var_valor_vendas[mes.valor], dataValida(dadosAno.ano, mes.id))  }} %-->
<!--                  </div>-->
<!--                </td>-->

<!--                <td class="px-2 text-center" v-show="colunaVisivel('ticket_medio_aa')">{{ (dadosAno.ticket_medio_aa[mes.valor] ? formataDinheiro(dadosAno.ticket_medio_aa[mes.valor]) : '-') }}</td>-->
<!--                <td class="px-2 text-center" v-show="colunaVisivel('ticket_medio')">{{ (dadosAno.ticket_medio[mes.valor] ? formataDinheiro(dadosAno.ticket_medio[mes.valor]) : '-') }}</td>-->
<!--                <td :class="corVariacao(dadosAno.var_ticket_medio[mes.valor])" class="px-5 text-center font-weight-medium" nowrap v-show="colunaVisivel('var_ticket_medio')">-->
<!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dadosAno.var_ticket_medio[mes.valor]>0">mdi-arrow-up-bold</v-icon>-->
<!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dadosAno.var_ticket_medio[mes.valor]<0">mdi-arrow-down-bold</v-icon>-->
<!--                  <div class="text-right" style="min-width: 60px;">-->
<!--                    {{ formataPercentual(dadosAno.var_ticket_medio[mes.valor], dataValida(dadosAno.ano, mes.id)) }} %-->
<!--                  </div>-->
<!--                </td>-->

<!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_clientes_aa')">{{ formataNumero(dadosAno.qtd_clientes_aa[mes.valor]) }}</td>-->
<!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_clientes')">{{ formataNumero(dadosAno.qtd_clientes[mes.valor]) }}</td>-->
<!--                <td :class="corVariacao(dadosAno.var_qtd_clientes[mes.valor])" class="px-5 text-center font-weight-medium" nowrap v-show="colunaVisivel('var_qtd_clientes')">-->
<!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dadosAno.var_qtd_clientes[mes.valor]>0">mdi-arrow-up-bold</v-icon>-->
<!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dadosAno.var_qtd_clientes[mes.valor]<0">mdi-arrow-down-bold</v-icon>-->
<!--                  <div class="text-right" style="min-width: 60px;">-->
<!--                    {{ formataPercentual(dadosAno.var_qtd_clientes[mes.valor], dataValida(dadosAno.ano, mes.id)) }} %-->
<!--                  </div>-->
<!--                </td>-->

<!--                <td class="px-3 text-center" nowrap v-show="colunaVisivel('per_lucros_aa')">{{ dadosAno.per_lucros_aa[mes.valor] ? dadosAno.per_lucros_aa[mes.valor].toFixed(2) + ' %' : '-'}}</td>-->
<!--                <td class="px-3 text-center" nowrap v-show="colunaVisivel('per_lucros')">{{ dadosAno.per_lucros[mes.valor] ? dadosAno.per_lucros[mes.valor].toFixed(2) + ' %' : '-'}}</td>-->
<!--                <td :class="corVariacao(dadosAno.var_per_lucros[mes.valor])" class="px-5 text-center font-weight-medium" nowrap v-show="colunaVisivel('var_per_lucros')">-->
<!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dadosAno.var_per_lucros[mes.valor]>0">mdi-arrow-up-bold</v-icon>-->
<!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dadosAno.var_per_lucros[mes.valor]<0">mdi-arrow-down-bold</v-icon>-->
<!--                  <v-icon color="grey" class="float-left mr-1" size="18" v-else-if="( dadosAno.ano < busca.anoAtual ) || ( dadosAno.ano <= busca.anoAtual && mes.id <= busca.mesAtual)">mdi-minus-thick</v-icon>-->
<!--                  <div class="text-right" style="min-width: 60px;">-->
<!--                    {{ formataPercentual(dadosAno.var_per_lucros[mes.valor], dataValida(dadosAno.ano, mes.id)) }} %-->
<!--                  </div>-->
<!--                </td>-->
<!--&lt;!&ndash;                <td class="px-3 text-center" v-show="colunaVisivel('media_ticket_clientes_aa')">{{ dadosAno.media_ticket_clientes_aa[mes.valor] ? dadosAno.media_ticket_clientes_aa[mes.valor].toFixed(2) : '-'}}</td>&ndash;&gt;-->
<!--&lt;!&ndash;                <td class="px-3 text-center" v-show="colunaVisivel('media_ticket_clientes')">{{ dadosAno.media_ticket_clientes[mes.valor] ? dadosAno.media_ticket_clientes[mes.valor].toFixed(2) : '-'}}</td>&ndash;&gt;-->
<!--&lt;!&ndash;                <td :class="corVariacao(dadosAno.var_media_ticket_clientes[mes.valor])" class="px-5 text-center font-weight-medium" nowrap v-show="colunaVisivel('var_media_ticket_clientes')">&ndash;&gt;-->
<!--&lt;!&ndash;                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dadosAno.var_media_ticket_clientes[mes.valor]>0">mdi-arrow-up-bold</v-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dadosAno.var_media_ticket_clientes[mes.valor]<0">mdi-arrow-down-bold</v-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                  <v-icon color="grey" class="float-left mr-1" size="18" v-else-if="( dadosAno.ano < busca.anoAtual ) || ( dadosAno.ano <= busca.anoAtual && mes.id <= busca.mesAtual)">mdi-minus-thick</v-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                  <div class="text-right" style="min-width: 60px;">&ndash;&gt;-->
<!--&lt;!&ndash;                    {{ formataPercentual(dadosAno.var_media_ticket_clientes[mes.valor], dataValida(dadosAno.ano, mes.id)) }}&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </td>&ndash;&gt;-->
<!--              </tr>-->
<!--              <tr class="grey lighten-4 font-weight-medium">-->
<!--                <td class="pa-2">-->
<!--                  <div-->
<!--                      class="d-flex align-center justify-space-between w-100"-->
<!--                      @click="toggleCollapse(i)"-->
<!--                      :style="{ cursor: 'pointer' }"-->
<!--                  >-->
<!--                    <span>Total {{ dadosAno.ano }}</span>-->
<!--                    <v-icon>{{ collapsedState[i] ? 'mdi-chevron-right' : 'mdi-chevron-up' }}</v-icon>-->
<!--                  </div>-->
<!--                </td>-->
<!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_vendas_aa')">{{ formataNumero(dadosAno.total_qtd_vendas_aa) }}</td>-->
<!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_vendas')">{{ formataNumero(dadosAno.total_qtd_vendas) }}</td>-->
<!--                <td :class="corVariacao(dadosAno.total_var_qtd_vendas)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_qtd_vendas')">-->
<!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dadosAno.total_var_qtd_vendas>0">mdi-arrow-up-bold</v-icon>-->
<!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dadosAno.total_var_qtd_vendas<0">mdi-arrow-down-bold</v-icon>-->
<!--                  <div class="text-right" style="min-width: 60px;">-->
<!--                    {{ formataPercentual(dadosAno.total_var_qtd_vendas) }} %-->
<!--                  </div>-->
<!--                </td>-->

<!--                <td class="px-2 text-center" v-show="colunaVisivel('valor_vendas_aa')">{{ formataDinheiro(dadosAno.total_valor_vendas_aa)  }}</td>-->
<!--                <td class="px-2 text-center" v-show="colunaVisivel('valor_vendas')">{{ formataDinheiro(dadosAno.total_valor_vendas)  }}</td>-->
<!--                <td :class="corVariacao(dadosAno.total_var_valor_vendas)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_valor_vendas')">-->
<!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dadosAno.total_var_valor_vendas>0">mdi-arrow-up-bold</v-icon>-->
<!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dadosAno.total_var_valor_vendas<0">mdi-arrow-down-bold</v-icon>-->
<!--                  <div class="text-right" style="min-width: 60px;">-->
<!--                    {{ formataPercentual(dadosAno.total_var_valor_vendas)  }} %-->
<!--                  </div>-->
<!--                </td>-->

<!--                <td class="px-2 text-center" v-show="colunaVisivel('ticket_medio_aa')">{{ formataDinheiro(dadosAno.total_ticket_medio_aa) }}</td>-->
<!--                <td class="px-2 text-center" v-show="colunaVisivel('ticket_medio')">{{ formataDinheiro(dadosAno.total_ticket_medio) }}</td>-->
<!--                <td :class="corVariacao(dadosAno.total_var_ticket_medio)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_ticket_medio')">-->
<!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dadosAno.total_var_ticket_medio>0">mdi-arrow-up-bold</v-icon>-->
<!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dadosAno.total_var_ticket_medio<0">mdi-arrow-down-bold</v-icon>-->
<!--                  <div class="text-right" style="min-width: 60px;">-->
<!--                    {{ formataPercentual(dadosAno.total_var_ticket_medio) }} %-->
<!--                  </div>-->
<!--                </td>-->

<!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_clientes_aa')">{{ formataNumero(dadosAno.total_qtd_clientes_aa) }}</td>-->
<!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_clientes')">{{ formataNumero(dadosAno.total_qtd_clientes) }}</td>-->
<!--                <td :class="corVariacao(dadosAno.total_var_qtd_clientes)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_qtd_clientes')">-->
<!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dadosAno.total_var_qtd_clientes>0">mdi-arrow-up-bold</v-icon>-->
<!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dadosAno.total_var_qtd_clientes<0">mdi-arrow-down-bold</v-icon>-->
<!--                  <div class="text-right" style="min-width: 60px;">-->
<!--                    {{ formataPercentual(dadosAno.total_var_qtd_clientes) }} %-->
<!--                  </div>-->
<!--                </td>-->

<!--                <td class="px-2 text-center" nowrap v-show="colunaVisivel('per_lucros_aa')">{{ dadosAno.total_per_lucro_aa ? dadosAno.total_per_lucro_aa.toFixed(2) + ' %' : '-'}}</td>-->
<!--                <td class="px-2 text-center" nowrap v-show="colunaVisivel('per_lucros')">{{ dadosAno.total_per_lucro ? dadosAno.total_per_lucro.toFixed(2) + ' %' : '-'}}</td>-->
<!--                <td :class="corVariacao(dadosAno.total_var_per_lucro)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_per_lucros')">-->
<!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dadosAno.total_var_per_lucro>0">mdi-arrow-up-bold</v-icon>-->
<!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dadosAno.total_var_per_lucro<0">mdi-arrow-down-bold</v-icon>-->
<!--                  <div class="text-right" style="min-width: 60px;">-->
<!--                    {{ formataPercentual(dadosAno.total_var_per_lucro) }} %-->
<!--                  </div>-->
<!--                </td>-->
<!--&lt;!&ndash;                <td class="px-2 text-center" v-show="colunaVisivel('media_ticket_clientes_aa')">{{ dadosAno.total_media_ticket_clientes_aa ? dadosAno.total_media_ticket_clientes_aa.toFixed(2) : '-'}}</td>&ndash;&gt;-->
<!--&lt;!&ndash;                <td class="px-2 text-center" v-show="colunaVisivel('media_ticket_clientes')">{{ dadosAno.total_media_ticket_clientes ? dadosAno.total_media_ticket_clientes.toFixed(2) : '-'}}</td>&ndash;&gt;-->
<!--&lt;!&ndash;                <td :class="corVariacao(dadosAno.total_var_media_ticket_clientes)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_media_ticket_clientes')">&ndash;&gt;-->
<!--&lt;!&ndash;                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dadosAno.total_var_media_ticket_clientes>0">mdi-arrow-up-bold</v-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dadosAno.total_var_media_ticket_clientes<0">mdi-arrow-down-bold</v-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                  <div class="text-right" style="min-width: 60px;">&ndash;&gt;-->
<!--&lt;!&ndash;                    {{ formataPercentual(dadosAno.total_var_media_ticket_clientes) }}&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </td>&ndash;&gt;-->
<!--              </tr>-->
<!--              </tbody>-->
              <tbody>
              <tr v-for="(mes, index) in dias" :key="`${index}`" v-show="!collapsedState[i]" class="fade-transition">
                <td class="px-2 text-center">{{ mes.dataCompleta | formataData }}</td>
                <td class="px-0 text-center">
<!--                  <v-row no-gutters class="font-weight-medium">-->
<!--                    <v-col cols="8" class="text-center bordered-col py-1 align-content-center">-->
<!--                      <h2> {{ mes.qtd_entregue }} </h2>-->
<!--                    </v-col>-->
<!--                    <v-col cols="4" class="text-center">-->
<!--                      <v-row no-gutters>-->
<!--                        <v-col cols="12" class="text-center bordered-col-success py-1 d-flex justify-space-around">-->
<!--                          <div>-->
<!--                            <v-icon color="success" size="20">mdi-clock-check</v-icon>-->
<!--                          </div>-->

<!--                          {{ mes.qtd_entregue_dia }}-->
<!--                        </v-col>-->
<!--                        <v-col cols="12" class="text-center bordered-col-error py-1 d-flex justify-space-around">-->
<!--                          <div>-->
<!--                            <v-icon color="error" size="20">mdi-clock-alert</v-icon>-->
<!--                          </div>-->

<!--                          {{ mes.qtd_entregue_atraso }}-->
<!--                        </v-col>-->
<!--                      </v-row>-->
<!--                    </v-col>-->
<!--                  </v-row>-->
                  {{ mes.qtd_entregue_dia }}
                </td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
                <td class="px-0 text-center">
                  {{ mes.qtd_entregue_dia }}
                </td>
<!--                <td class="px-0 text-center">-->
<!--                  {{ mes.qtd_entregue_dia }}-->
<!--                </td>-->
<!--                <td class="px-0 text-center">-->
<!--                  {{ mes.qtd_entregue_dia }}-->
<!--                </td>-->
<!--                <td class="px-0 text-center">-->
<!--                  <v-row no-gutters class="font-weight-medium">-->
<!--                    <v-col cols="8" class="text-center bordered-col py-1 align-content-center">-->
<!--                      <h2> {{ mes.qtd_entregue }} </h2>-->
<!--                    </v-col>-->
<!--                    <v-col cols="4" class="text-center">-->
<!--                      <v-row no-gutters>-->
<!--                        <v-col cols="12" class="text-center bordered-col-success py-1 d-flex justify-space-around">-->
<!--                          <div>-->
<!--                            <v-icon color="success" size="20">mdi-clock-check</v-icon>-->
<!--                          </div>-->

<!--                          {{ mes.qtd_entregue_dia }}-->
<!--                        </v-col>-->
<!--                        <v-col cols="12" class="text-center bordered-col-error py-1 d-flex justify-space-around">-->
<!--                          <div>-->
<!--                            <v-icon color="error" size="20">mdi-clock-alert</v-icon>-->
<!--                          </div>-->

<!--                          {{ mes.qtd_entregue_atraso }}-->
<!--                        </v-col>-->
<!--                      </v-row>-->
<!--                    </v-col>-->
<!--                  </v-row>-->
<!--                </td>-->
<!--                <td class="px-0">-->
<!--                  <v-row no-gutters>-->
<!--                    <v-col class="text-center">-->
<!--                      <v-row no-gutters>-->
<!--                        <v-col cols="12" class="text-center bordered-col2 py-1 d-flex justify-space-around">-->
<!--                          {{ mes.qtd_entregue_dia }}-->
<!--                        </v-col>-->
<!--                        <v-col cols="12" class="text-center bordered-col2 py-1 d-flex justify-space-around">-->
<!--                          1 dia-->
<!--                        </v-col>-->
<!--                      </v-row>-->
<!--                    </v-col>-->
<!--                    <v-col class="text-center">-->
<!--                      <v-row no-gutters>-->
<!--                        <v-col cols="12" class="text-center bordered-col2 py-1 d-flex justify-space-around">-->
<!--                          {{ mes.qtd_entregue_dia }}-->
<!--                        </v-col>-->
<!--                        <v-col cols="12" class="text-center bordered-col2 py-1 d-flex justify-space-around">-->
<!--                          7 dias-->
<!--                        </v-col>-->
<!--                      </v-row>-->
<!--                    </v-col>-->
<!--                    <v-col class="text-center">-->
<!--                      <v-row no-gutters>-->
<!--                        <v-col cols="12" class="text-center bordered-col2 py-1 d-flex justify-space-around">-->
<!--                          {{ mes.qtd_entregue_dia }}-->
<!--                        </v-col>-->
<!--                        <v-col cols="12" class="text-center bordered-col2 py-1 d-flex justify-space-around">-->
<!--                          15 dias-->
<!--                        </v-col>-->
<!--                      </v-row>-->
<!--                    </v-col>-->
<!--                    <v-col class="text-center">-->
<!--                      <v-row no-gutters>-->
<!--                        <v-col cols="12" class="text-center bordered-col2 py-1 d-flex justify-space-around">-->
<!--                          {{ mes.qtd_entregue_dia }}-->
<!--                        </v-col>-->
<!--                        <v-col cols="12" class="text-center bordered-col2 py-1 d-flex justify-space-around">-->
<!--                          30 dias-->
<!--                        </v-col>-->
<!--                      </v-row>-->
<!--                    </v-col>-->
<!--                  </v-row>-->
<!--                </td>-->
<!--                <td class="px-0 text-center">-->
<!--                  {{ mes.qtd_entregar }}-->
<!--                </td>-->
<!--                <td class="px-0 text-center">-->
<!--                  {{ mes.qtd_entregar }}-->
<!--                </td>-->
<!--                <td class="px-0 text-center">-->
<!--                  {{ mes.qtd_entregar }}-->
<!--                </td>-->
<!--                <td class="px-0 text-center">-->
<!--                  {{ mes.qtd_entregar }}-->
<!--                </td>-->
<!--                <td class="px-0 text-center">-->
<!--                  <div class="d-flex justify-space-around">-->
<!--                    <v-chip color="primary" small>-->
<!--                      1 dia-->
<!--                    </v-chip>-->
<!--                    <v-chip color="primary" small>-->
<!--                      7 dias-->
<!--                    </v-chip>-->
<!--                    <v-chip color="primary" small>-->
<!--                      15 dias-->
<!--                    </v-chip>-->
<!--                    <v-chip color="primary" small>-->
<!--                      1 Mês-->
<!--                    </v-chip>-->
<!--                  </div>-->
<!--                </td>-->
<!--                <td class="px-2 text-center">{{ mes.qtd_entregar_atraso }}</td>-->
              </tr>
              </tbody>
<!--              <tfoot>-->
<!--              <tr class="font-weight-bold grey lighten-4">-->
<!--                <td class="pa-2">Total Geral</td>-->

<!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_vendas_aa')">{{ formataNumero(dados.total_geral_qtd_vendas_aa) }}</td>-->
<!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_vendas')">{{ formataNumero(dados.total_geral_qtd_vendas) }}</td>-->
<!--                <td :class="corVariacao(dados.total_geral_var_qtd_vendas)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_qtd_vendas')">-->
<!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dados.total_geral_var_qtd_vendas>0">mdi-arrow-up-bold</v-icon>-->
<!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dados.total_geral_var_qtd_vendas<0">mdi-arrow-down-bold</v-icon>-->
<!--                  <div class="text-right" style="min-width: 60px;">-->
<!--                    {{ formataPercentual(dados.total_geral_var_qtd_vendas) }} %-->
<!--                  </div>-->
<!--                </td>-->

<!--                <td class="px-2 text-center" v-show="colunaVisivel('valor_vendas_aa')">{{ dados.total_geral_valor_vendas_aa | formataDinheiro }}</td>-->
<!--                <td class="px-2 text-center" v-show="colunaVisivel('valor_vendas')">{{ dados.total_geral_valor_vendas | formataDinheiro }}</td>-->
<!--                <td :class="corVariacao(dados.total_geral_var_valor_vendas)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_valor_vendas')">-->
<!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dados.total_geral_var_valor_vendas>0">mdi-arrow-up-bold</v-icon>-->
<!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dados.total_geral_var_valor_vendas<0">mdi-arrow-down-bold</v-icon>-->
<!--                  <div class="text-right" style="min-width: 60px;">-->
<!--                    {{ formataPercentual(dados.total_geral_var_valor_vendas) }} %-->
<!--                  </div>-->
<!--                </td>-->

<!--                <td class="px-2 text-center" v-show="colunaVisivel('ticket_medio_aa')">{{ dados.total_geral_ticket_medio_aa | formataDinheiro }}</td>-->
<!--                <td class="px-2 text-center" v-show="colunaVisivel('ticket_medio')">{{ dados.total_geral_ticket_medio | formataDinheiro }}</td>-->
<!--                <td :class="corVariacao(dados.total_geral_var_ticket_medio)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_ticket_medio')">-->
<!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dados.total_geral_var_ticket_medio>0">mdi-arrow-up-bold</v-icon>-->
<!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dados.total_geral_var_ticket_medio<0">mdi-arrow-down-bold</v-icon>-->
<!--                  <div class="text-right" style="min-width: 60px;">-->
<!--                    {{ formataPercentual(dados.total_geral_var_ticket_medio) }} %-->
<!--                  </div>-->
<!--                </td>-->

<!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_clientes_aa')">{{ formataNumero(dados.total_geral_qtd_clientes_aa) }}</td>-->
<!--                <td class="px-2 text-center" v-show="colunaVisivel('qtd_clientes')">{{ formataNumero(dados.total_geral_qtd_clientes) }}</td>-->
<!--                <td :class="corVariacao(dados.total_geral_var_qtd_clientes)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_qtd_clientes')">-->
<!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dados.total_geral_var_qtd_clientes>0">mdi-arrow-up-bold</v-icon>-->
<!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dados.total_geral_var_qtd_clientes<0">mdi-arrow-down-bold</v-icon>-->
<!--                  <div class="text-right" style="min-width: 60px;">-->
<!--                    {{ formataPercentual(dados.total_geral_var_qtd_clientes) }} %-->
<!--                  </div>-->
<!--                </td>-->

<!--                <td class="px-2 text-center" v-show="colunaVisivel('per_lucros_aa')">{{ dados.total_geral_per_lucro_aa ? dados.total_geral_per_lucro_aa.toFixed(2) + ' %' : '-' }}</td>-->
<!--                <td class="px-2 text-center" v-show="colunaVisivel('per_lucros')">{{ dados.total_geral_per_lucro ? dados.total_geral_per_lucro.toFixed(2) + ' %' : '-' }}</td>-->
<!--                <td :class="corVariacao(dados.total_geral_var_per_lucro)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_per_lucros')">-->
<!--                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dados.total_geral_var_per_lucro>0">mdi-arrow-up-bold</v-icon>-->
<!--                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dados.total_geral_var_per_lucro<0">mdi-arrow-down-bold</v-icon>-->
<!--                  <div class="text-right" style="min-width: 60px;">-->
<!--                    {{ formataPercentual(dados.total_geral_var_per_lucro) }} %-->
<!--                  </div>-->
<!--                </td>-->
<!--&lt;!&ndash;                <td class="px-2 text-center" v-show="colunaVisivel('media_ticket_clientes_aa')">{{ dados.total_geral_media_ticket_clientes_aa ? dados.total_geral_media_ticket_clientes_aa.toFixed(2) : '-' }}</td>&ndash;&gt;-->
<!--&lt;!&ndash;                <td class="px-2 text-center" v-show="colunaVisivel('media_ticket_clientes')">{{ dados.total_geral_media_ticket_clientes ? dados.total_geral_media_ticket_clientes.toFixed(2) : '-' }}</td>&ndash;&gt;-->
<!--&lt;!&ndash;                <td :class="corVariacao(dados.total_geral_var_media_ticket_clientes)" class="px-5 text-center" nowrap v-show="colunaVisivel('var_media_ticket_clientes')">&ndash;&gt;-->
<!--&lt;!&ndash;                  <v-icon color="blue" class="float-left mr-1" size="18" v-if="dados.total_geral_var_media_ticket_clientes>0">mdi-arrow-up-bold</v-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                  <v-icon color="red" class="float-left mr-1" size="18" v-else-if="dados.total_geral_var_media_ticket_clientes<0">mdi-arrow-down-bold</v-icon>&ndash;&gt;-->
<!--&lt;!&ndash;                  <div class="text-right" style="min-width: 60px;">&ndash;&gt;-->
<!--&lt;!&ndash;                    {{ formataPercentual(dados.total_geral_var_media_ticket_clientes) }}&ndash;&gt;-->
<!--&lt;!&ndash;                  </div>&ndash;&gt;-->
<!--&lt;!&ndash;                </td>&ndash;&gt;-->
<!--              </tr>-->
<!--              </tfoot>-->
            </template>
          </v-simple-table>

          <!-- SELEÇÃO DO INDICADOR -->
          <v-card class="align-content-center align-center" light v-else max-height="500px">
            <v-sheet height="500">
              <v-calendar
                  ref="calendar"
              ></v-calendar>
            </v-sheet>
          </v-card>
        </v-card-text>
        <v-progress-linear indeterminate absolute :active="carregando" />
      </v-card>
    </template>
    <!-- VISÃO DISPOSITIVOS MÓVEIS -->
    <template v-else-if="false">
      <!-- FILTROS -->
      <v-card elevation="1">
        <v-card-title>
          <v-row no-gutters>
            <v-col class="pr-2">
              <v-select
                  :items="filiaisFiltro"
                  item-text="filial"
                  item-value="idfilial"
                  label="Filial"
                  outlined
                  dense
                  v-model="busca.idfiliais"
                  hide-details
                  multiple
                  class="single-line-selection"
                  @change="listar()"
              >
                <template v-slot:selection="{ item, index }">
                  <template v-if="selectAllChecked">
                    <span v-if="index === 0">Todas filiais</span>
                  </template>
                  <template v-else>
                    <span v-if="index === 0" class="mr-1">{{ item.filial }}</span>
                    <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ busca.idfiliais.length - 1 }})
                  </span>
                  </template>
                </template>

                <template #prepend-item>
                  <v-list-item
                      class="pr-0"
                      dense
                      :style="{
                      backgroundColor: selectAllChecked ? '#D0D6D9' : 'transparent'
                    }"
                  >
                    <v-list-item-action>
                      <v-checkbox v-model="selectAllChecked" @click.stop="toggleSelectAll('CHECKBOX')"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content @click="toggleSelectAll('LABEL')">
                      <label class="text-subtitle-2">Todas filiais</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
            <v-col class="px-1">
              <v-autocomplete
                  :disabled="carregando"
                  dense
                  outlined
                  :items="anos"
                  v-model="busca.ano"
                  @change="listar()"
                  hide-details
                  multiple
                  label="Períodos"
              >
                <template v-slot:selection="{ item, index }">
                  <template v-if="index === 0">{{ item }}</template>
                  <span
                      v-if="index === 1"
                      class="grey--text text-caption ml-1"
                  >(+{{ busca.ano.length - 1 }})</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>

      <v-card class="mt-5" dark color="primary" elevation="1">
        <v-card-title class="px-3 py-2">
          Desempenho de Vendas <br/> {{ dados.vendas ? dados.vendas.map(v => v.ano).join(', ') : ''}}
        </v-card-title>
        <v-progress-linear small indeterminate absolute :active="carregando" />
        <v-divider/>
        <v-card-text class="pa-2 pb-1">
          <v-card elevation="0" flat style="background-color: transparent !important;" light>
            <v-container class="py-0">
              <v-card-text v-for="(dadosAno, i) in dados.vendas" :key="i" class="elevation-0 pa-0 mb-6">
                <v-row v-for="(mes, index) in mesesNomes" :key="index" class="mb-1 mt-2">
                  <v-col cols="12" class="pa-0">
                    <v-card rounded="0">
                      <v-card-subtitle class="text-center pa-0 font-weight-bold" style="background-color: #f4f4f4">
                        <v-hover v-slot="{ hover }">
                          <div
                              class="w-100 pl-2 pr-2 py-2"
                              :style="{ backgroundColor: hover ? '#E0E0E0' : 'transparent', cursor: 'pointer' }"
                              @click="detalharMes(dadosAno.ano, mes)"
                          >
                            <span>{{ mes.titulo }} {{ dadosAno.ano }} </span>
                            <v-icon class="ml-1 mr-n6">mdi-magnify-plus-outline</v-icon>
                          </div>
                        </v-hover>
                      </v-card-subtitle>
                      <v-divider/>
                      <v-card-text class="pa-0 text-caption">
                        <v-row no-gutters>
                          <v-col cols="6" class="text-center bordered-col py-1">
                            <strong> Qtde de Tickets: </strong> <v-spacer/> {{dadosAno.qtd_vendas[mes.valor] || '-'}} <br/>
                          </v-col>
                          <v-col cols="6" class="text-center bordered-col py-1">
                            <strong> Qtde de Clientes: </strong> <v-spacer/>{{ dadosAno.qtd_clientes[mes.valor] || '-' }}<br/>
                          </v-col>
                          <v-col cols="6" class="text-center bordered-col py-1">
                            <strong> Valor de Vendas: </strong> <v-spacer/> {{ (dadosAno.valor_vendas[mes.valor] ? formataDinheiro(dadosAno.valor_vendas[mes.valor]) : '-') }} <br/>
                          </v-col>
                          <v-col cols="6" class="text-center bordered-col py-1">
                            <strong> Ticket Médio: </strong> <v-spacer/>{{ (dadosAno.ticket_medio[mes.valor] ? formataDinheiro(dadosAno.ticket_medio[mes.valor]) : '-') }}<br/>
                          </v-col>
                          <v-col cols="12" class="text-center bordered-col py-1">
                            <strong> Média de Ticket por Clientes: </strong> <v-spacer/>{{ dadosAno.media_ticket_clientes[mes.valor] ? dadosAno.media_ticket_clientes[mes.valor].toFixed(2) : '-' }}
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-container>
          </v-card>
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import mixinFilial from "../../util/mixinFilial";
import CardDashboard from "@/Components/Widgets/CardDashboard.vue";

export default {
  name: "DashboardLogistica",
  components: {CardDashboard},
  mixins: [mixinFilial],
  data: () => ({
    busca: {
      offsetSemana: 0, // 0 = semana atual
      dataInicial: null,
      dataFinal: null,
      anoAtual: new Date().getFullYear(),
      mesAtual: new Date().getMonth() + 1,
      ano: [new Date().getFullYear()],
      mes: null,
      idfiliais: null,
      tipo_periodo: 'semana',
    },

    menuInicial: false,
    menuFinal: false,

    filtro_periodo: [
      { tipo: 'semana', nome: 'Semana' },
      // { tipo: 'mes', nome: 'Mês' },
      { tipo: 'personalizado', nome: 'Personalizado' },
    ],
    hoveredLote: null,
    lotes: [],
    isHeaderFixed: false,
    fixationThreshold: 50,
    releaseThreshold: 60,
    throttleTimer: null,
    originalWidths: null,
    columnVisibilityHash: null, // Para detectar mudanças na visibilidade das colunas

    allCollapsed: false, // Estado que controla se todos estão recolhidos ou não
    showAllData: false,
    collapsedState: [], // Array que armazenará o estado de collapse para cada ano

    dialogFiliais:false,
    selectAllChecked: false,
    dialogGrafico: false,

    dialogDetalhePrecarga: false,
    detalheLote: [],
    nomeEmpresaDialog: '',

    graficoSelecionado: 'table-coluna',
    indicadorSelecionado: null,

    tituloDialog: '',

    anos: Array.from({ length: new Date().getFullYear() - 2019 + 1 }, (_, i) => 2019 + i).reverse(),

    meses: ["janeiro", "fevereiro", "marco", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"],

    mesesNomes: [
      { id: 1, titulo:"Janeiro", valor: "janeiro", apelido:"Jan" },
      { id: 2, titulo:"Fevereiro", valor: "fevereiro", apelido:"Fev" },
      { id: 3, titulo:"Março", valor: "marco", apelido:"Mar" },
      { id: 4, titulo:"Abril", valor: "abril", apelido:"Abr" },
      { id: 5, titulo:"Maio", valor: "maio", apelido:"Mai" },
      { id: 6, titulo:"Junho", valor: "junho", apelido:"Jun" },
      { id: 7, titulo:"Julho", valor: "julho", apelido:"Jul" },
      { id: 8, titulo:"Agosto", valor: "agosto", apelido:"Ago" },
      { id: 9, titulo:"Setembro", valor: "setembro", apelido:"Set" },
      { id: 10, titulo:"Outubro", valor: "outubro", apelido:"Out" },
      { id: 11, titulo:"Novembro", valor: "novembro", apelido:"Nov" },
      { id: 12, titulo:"Dezembro", valor: "dezembro", apelido:"Dez" }
    ],

    colunas: [
      { titulo: "Qtde de Tickets AA", valor: "qtd_vendas_aa" },
      { titulo: "Qtde de Tickets", valor: "qtd_vendas" },
      { titulo: "% Var. Qtde de Tickets AA", valor: "var_qtd_vendas"},
      { titulo: "Valor de Vendas AA", valor: "valor_vendas_aa" },
      { titulo: "Valor de Vendas", valor: "valor_vendas" },
      { titulo: "% Var. Valor de Vendas AA", valor: "var_valor_vendas"},
      { titulo: "Ticket Médio AA", valor: "ticket_medio_aa" },
      { titulo: "Ticket Médio", valor: "ticket_medio" },
      { titulo: "% Var. Ticket Médio AA", valor: "var_ticket_medio"},
      { titulo: "Qtde de Clientes AA", valor: "qtd_clientes_aa" },
      { titulo: "Qtde de Clientes", valor: "qtd_clientes" },
      { titulo: "% Var. Qtde de Clientes AA", valor: "var_qtd_clientes"},
      { titulo: "Margem AA", valor: "per_lucros_aa" },
      { titulo: "Margem", valor: "per_lucros" },
      { titulo: "% Var. Margem AA", valor: "var_per_lucros"},
      // { titulo: "Média de Ticket por Clientes AA", valor: "media_ticket_clientes_aa" },
      // { titulo: "Média de Ticket por Clientes", valor: "media_ticket_clientes" },
      // { titulo: "% Var. Média de Ticket por Clientes", valor: "var_media_ticket_clientes"},
    ],

    gruposColunas: [
      {
        nome: "Dados do Lote",
        visible: true,
        colunas: [
          { titulo: "Qtde de Pedidos", valor: "qtd_pedido", visible: true },
          { titulo: "Qtde de Skus", valor: "qtd_sku", visible: true },
          { titulo: "Valor Total", valor: "valor_pedido", visible: true },
          { titulo: "Qtde de Skus Atendidos", valor: "qtd_sku_atendido", visible: true },
          { titulo: "Valor Total Atendido", valor: "valor_pedido_atendido", visible: true },
          { titulo: "% Skus Atendidos", valor: "per_qtd_sku_atendido", visible: true },
          { titulo: "% Valor Atendido", valor: "per_valor_pedido_atendido", visible: true },
        ]
      },
      {
        nome: "Tempo Médio de Execução",
        visible: false,
        colunas: [
          { titulo: "Pedido", valor: "tempo_pedido", visible: true },
          { titulo: "Separação", valor: "tempo_separacao", visible: true },
          { titulo: "Entrega", valor: "tempo_entrega", visible: true },
          { titulo: "Entrada", valor: "tempo_entrada", visible: true },
          { titulo: "Geral", valor: "tempo_geral", visible: true },
        ]
      },
      {
        nome: "Divergência",
        visible: false,
        colunas: [
          { titulo: "Qtde de Ocorrências", valor: "qtd_ocorrencia", visible: true },
          { titulo: "Valor Total", valor: "valor_divergencia", visible: true },
          { titulo: "% de Divergência", valor: "per_divergencia", visible: true },
        ]
      }
    ],

    dados: [],

    dadosFiliais: [],

    pieOptions: {
      chart: { type: 'pie', height: 200 },
      labels: [],
    },
    pieSeries: [],
    lineOptions: {
      chart: { type: 'line', height: 200 },
      xaxis: { categories: [] },
    },
    lineSeries: [],
    barOptions: {
      chart: { type: 'bar', height: 200 },
      xaxis: { categories: [] },
    },
    barSeries: [],

    snackbar: { status: false, timeout: 2000, text: 'Erro: tente recarregar a pagina!' , color: 'red' },

    carregando: false,
    carregando2: false,
    carregandoSkeleton: true,

    ano: null,
  }),
  watch: {
    'busca.idfiliais'(newValue) {
      if (newValue.length === 0 || newValue.length !== this.filiaisFiltro.length) {
        this.selectAllChecked = false;
      } else {
        this.selectAllChecked = true;
      }
    },
    // Assistir a estrutura gruposColunas para detectar mudanças de visibilidade
    gruposColunas: {
      handler(newValue) {
        // Gerar um hash da visibilidade atual das colunas
        const newHash = this.generateColumnVisibilityHash(newValue);

        // Se o hash mudou, resetamos as larguras armazenadas
        if (newHash !== this.columnVisibilityHash) {
          this.columnVisibilityHash = newHash;
          this.originalWidths = null; // Forçar recálculo das larguras

          // Se o cabeçalho está fixo, precisamos atualizar as larguras
          if (this.isHeaderFixed) {
            // Aguardar a renderização do DOM com as novas colunas
            this.$nextTick(() => {
              const table = document.getElementById('minha-tabela');
              if (table) {
                this.releaseHeader(table); // Remover cabeçalho fixo

                // Reativar o cabeçalho fixo se a condição ainda for verdadeira
                this.$nextTick(() => {
                  this.handleScroll();
                });
              }
            });
          }
        }
      },
      deep: true // Monitorar mudanças profundas na estrutura
    }
  },
  computed: {
    ...mapState(["backendUrl", "pgLimit", "usuario"]),
    filiaisFiltro() {
      if (this.filiais.lista) {
        return this.filiais.lista.filter((v) => {
          return (
              v.idfilial !== 4 &&
              v.idfilial !== 6 &&
              v.idfilial !== 12 &&
              v.idfilial !== 13 &&
              v.idfilial !== 25 &&
              v.idfilial !== 28 &&
              v.idfilial !== 29 &&
              v.idfilial !== 33 &&
              v.idfilial !== 37 &&
              v.idfilial !== 40 &&
              v.idfilial !== 42 &&
              v.idfilial !== 43
          );
        });
      } else {
        return [];
      }
    },
    colspanValor() {
      const visiveis = this.gruposColunas.filter(g => g.visible).length;
      return visiveis > 0 ? Math.floor(7 / visiveis) : 7;
    },
    dataInicialFormatada() {
      return this.formatarData(this.busca.dataInicial);
    },
    dataFinalFormatada() {
      return this.formatarData(this.busca.dataFinal);
    },
    periodoFormatado() {
      if (!this.busca.dataInicial || !this.busca.dataFinal) return '';
      return `${this.formatarData(this.busca.dataInicial)} a ${this.formatarData(this.busca.dataFinal)}`;
    },
    linhasTabela() {
      const linhas = [];

      (this.lotes || []).forEach((lote, loteIndex) => {
        (lote?.lojas || []).forEach((loja, lojaIndex) => {
          linhas.push({
            tipo: 'loja',
            loja,
            lote,
            loteIndex,
            lojaIndex,
            exibirLote: lojaIndex === 0,
            rowspan: lote?.lojas?.length || 1
          });
        });

        linhas.push({
          tipo: 'subtotal',
          lote,
          loteIndex
        });
      });

      return linhas;
    },
    totalGeral() {
      const toNumber = (value) => {
        if (value == null || value === '') return 0;
        if (typeof value === 'number') return isNaN(value) ? 0 : value;

        const n = Number(value);
        return isNaN(n) ? 0 : n;
      };

      return (this.lotes || []).reduce((acc, lote) => {
        (lote?.lojas || []).forEach(loja => {
          acc.qtd_pedido += toNumber(loja?.qtd_pedido);
          acc.qtd_sku += toNumber(loja?.qtd_sku);
          acc.valor += toNumber(loja?.total_valor);
          acc.qtd_pedido_atendido += toNumber(loja?.qtd_pedido_atendido);
          acc.valor_atendido += toNumber(loja?.valor_atendido);
        });

        return acc;
      }, {
        qtd_pedido: 0,
        qtd_sku: 0,
        valor: 0,
        qtd_pedido_atendido: 0,
        valor_atendido: 0,
      });
    },
  },
  methods: {
    somarPorLote(lojas, campo) {
      if (!campo) return 0; // Campo null, undefined ou vazio retorna 0

      return (lojas || []).reduce((total, loja) => {
        const valor = loja && loja[campo] != null ? Number(loja[campo]) : 0;
        return total + (isNaN(valor) ? 0 : valor);
      }, 0);
    },
    atualizarPeriodo() {
      const hoje = new Date();
      const quinta = this.getQuintaDaSemana(hoje, this.busca.offsetSemana);
      const quarta = this.getQuartaSeguinte(quinta);
      this.busca.dataInicial = quinta.toISOString().split('T')[0];
      this.busca.dataFinal = quarta.toISOString().split('T')[0];
      this.listar();
    },
    getQuintaDaSemana(referencia, offsetSemanas) {
      const ref = new Date(referencia);
      const dia = ref.getDay(); // 0-dom, 1-seg,..., 4-qui
      let diff;

      if (dia >= 4) {
        // Hoje é quinta (4) ou depois (sexta, sábado)
        diff = - (dia - 4);
      } else {
        // Antes de quinta
        diff = - (7 - (4 - dia));
      }

      ref.setDate(ref.getDate() + diff + (offsetSemanas * 7));
      return ref;
    },
    getQuartaSeguinte(quinta) {
      const quarta = new Date(quinta);
      quarta.setDate(quinta.getDate() + 6); // próxima quarta após quinta
      return quarta;
    },
    avancarSemana() {
      this.busca.offsetSemana += 1;
      this.atualizarPeriodo();
    },
    voltarSemana() {
      console.log('teste ', this.busca.offsetSemana)
      this.busca.offsetSemana -= 1;
      this.atualizarPeriodo();
    },
    getProximaQuarta() {
      const hoje = new Date();
      const diaAtual = hoje.getDay(); // 0 = domingo, 3 = quarta

      const diasAteQuarta = (3 - diaAtual + 7) % 7;
      const proximaQuarta = new Date(hoje);
      proximaQuarta.setDate(hoje.getDate() + diasAteQuarta);

      this.busca.dataFinal = proximaQuarta.toISOString().split('T')[0];
    },
    getUltimaOuAtualQuinta() {
      const hoje = new Date();
      const diaDaSemana = hoje.getDay();

      const diferenca = diaDaSemana >= 4 ? diaDaSemana - 4 : 7 - (4 - diaDaSemana);
      const quinta = new Date(hoje);
      quinta.setDate(hoje.getDate() - diferenca);

      this.busca.dataInicial = quinta.toISOString().split('T')[0];
    },
    apenasQuartas(data) {
      const dia = new Date(data).getDay();
      return dia === 2;
    },
    apenasQuintas(data) {
      const dia = new Date(data).getDay();
      return dia === 3;
    },
    formatarData(dataISO) {
      if (!dataISO) return '';
      const [ano, mes, dia] = dataISO.split('-');
      return `${dia}/${mes}/${ano}`;
    },
    getIntervaloDatas(date) {
      if (!this.busca.dataInicial || !this.busca.dataFinal) return false;

      const d = new Date(date);
      const inicio = new Date(this.busca.dataInicial);
      const fim = new Date(this.busca.dataFinal);

      // Normaliza datas para ignorar horário
      d.setHours(0, 0, 0, 0);
      inicio.setHours(0, 0, 0, 0);
      fim.setHours(0, 0, 0, 0);

      return d >= inicio && d <= fim;
    },

    formatarTempo(loja, tipo = 'pedido') {

      const dias = loja[`dias_${tipo}`];
      const horas = loja[`horas_${tipo}`];
      const minutos = loja[`minutos_${tipo}`];

      if (dias > 0) return `${dias} dia${dias > 1 ? 's' : ''}`;
      if (horas > 0) return `${horas} hora${horas > 1 ? 's' : ''}`;
      if (minutos > 0) return `${minutos} minuto${minutos > 1 ? 's' : ''}`;
      return '-'
    },

    listar() {
      this.lotes = [];
      this.carregando = true;
      this.carregandoSkeleton = true;
      return axios
          .post(`${this.backendUrl}dashboard/logistico/main/listar`, {
            dtini: this.busca.dataInicial,
            dtfim: this.busca.dataFinal,
          })
          .then((res) => {
            this.lotes = res.data.Lotes;
            if (this.allCollapsed) {
              this.collapsedState = new Array(this.dados.vendas.length).fill(true);
            } else {
              this.collapsedState = new Array(this.dados.vendas.length).fill(false);
            }
            this.updateCharts();
          })
          .catch(() => {
          })
          .finally(() => {
            this.carregando = false;
            this.carregandoSkeleton = false;
          });
    },

    listarPrecargas(lote, idempresa, empresa) {
      this.nomeEmpresaDialog = empresa;
      this.carregando2 = true;
      this.detalheLote = [];
      return axios
          .post(`${this.backendUrl}dashboard/logistico/precargas/listar`, {
            dtini: this.busca.dataInicial,
            dtfim: this.busca.dataFinal,
            lote: lote,
            idempresa: idempresa,
          })
          .then((res) => {
            this.detalheLote = res.data.Precargas;
            if (this.allCollapsed) {
              this.collapsedState = new Array(this.dados.vendas.length).fill(true);
            } else {
              this.collapsedState = new Array(this.dados.vendas.length).fill(false);
            }

            //this.updateCharts();
          })
          .catch(() => {
          })
          .finally(() => {
            this.carregando2 = false;
          });
    },


    // Suponha que você tenha selecionado "2025-01"

    gerarDiasDoMes(mesAno) {
      const [ano, mes] = mesAno.split("-").map(Number);
      const dias = [];
      const totalDias = new Date(ano, mes, 0).getDate(); // último dia do mês

      const nomesDias = ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"];

      for (let dia = 1; dia <= totalDias; dia++) {
        const data = new Date(ano, mes - 1, dia);
        dias.push({
          dia: dia.toString().padStart(2, "0"),
          semana: nomesDias[data.getDay()],
          dataCompleta: `${ano}-${mes.toString().padStart(2, "0")}-${dia.toString().padStart(2, "0")}`
        });
      }

      // this.dias = dias;
    },

    dataValida(ano, mes) {
      return ( ano < this.busca.anoAtual ) || ( ano <= this.busca.anoAtual && mes <= this.busca.mesAtual );
    },

    toggleCollapse(index) {
      this.$set(this.collapsedState, index, !this.collapsedState[index]);

      // Verifica se todos os itens estão com o mesmo estado para atualizar allCollapsed
      const allSame = this.collapsedState.every(state => state === this.collapsedState[0]);

      if (allSame) {
        this.allCollapsed = this.collapsedState[0];
      }
    },

    toggleAll() {
      // Inverte o estado atual de allCollapsed
      this.allCollapsed = !this.allCollapsed;

      // Aplica o novo estado a todos os itens
      this.collapsedState = new Array(this.busca.ano.length).fill(this.allCollapsed);
    },

    corVariacao(valor){
      if (valor > 0) {
        return 'blue--text'
      } else if (valor < 0) {
        return 'red--text'
      } else {
        return 'grey--text'
      }
    },

    mostrarColuna(index) {
      this.gruposColunas.forEach((coluna, i) => {
        this.$set(coluna, 'visible', i === index);
      });
    },

    colunaVisivel(valorColuna) {
      // Verifica em todos os grupos se a coluna existe e está visível
      for (const grupo of this.gruposColunas) {
        if (!grupo.visible) continue; // Se o grupo não está visível, pule

        const coluna = grupo.colunas.find(col => col.valor === valorColuna);
        if (coluna && coluna.visible) {
          return true;
        }
      }
      return false;
    },

    toggleGrupo(grupoIndex) {
      const grupo = this.gruposColunas[grupoIndex];
      // Atualiza a visibilidade de todas as colunas do grupo
      grupo.colunas.forEach(coluna => {
        coluna.visible = grupo.visible;
      });
    },

    toggleColuna(grupoIndex) {
      const grupo = this.gruposColunas[grupoIndex];

      const numCol = grupo.colunas.filter(coluna => coluna.visible).length;

      if (numCol === 0) {
        grupo.visible = false;
      } else {
        grupo.visible = true;
      }
    },

    toggleSelectAll(tipo) {
      if (tipo == 'CHECKBOX') {
        if (this.selectAllChecked) {
          // Se a opção "Selecionar Todos" estiver desmarcada, selecionar todas as filiais
          this.busca.idfiliais = this.filiaisFiltro.map(item => item.idfilial);
          this.listar();
        } else {
          // Se a opção "Selecionar Todos" estiver marcada, limpar todas as seleções
          this.busca.idfiliais = [];
        }
      } else {
        if (!this.selectAllChecked) {
          // Se a opção "Selecionar Todos" estiver desmarcada, selecionar todas as filiais
          this.busca.idfiliais = this.filiaisFiltro.map(item => item.idfilial);
          this.listar();
        } else {
          // Se a opção "Selecionar Todos" estiver marcada, limpar todas as seleções
          this.busca.idfiliais = [];
        }
        this.selectAllChecked = !this.selectAllChecked;
      }
    },

    selecionarGrafico(tipo) {
      this.graficoSelecionado = tipo;
      // if(tipo==='table'){
      //   this.indicadorSelecionado = null;
      // }
    },

    selecionarIndicador(indicador) {
      this.indicadorSelecionado = indicador;
      this.updateCharts();
    },

    detalharMes(ano, mes) {
      this.tituloDialog = mes.apelido;
      this.busca.mes = mes.id;
      this.ano = ano;
      this.dialogFiliais=true;
      this.carregando = true;
      return axios
          .post(`${this.backendUrl}dashboard/marketing/tickets/mes/listar`, {
            idfilial: this.busca.idfiliais.join(',') || null,
            ano: ano.toString() || null,
            mes: this.busca.mes.toString(),
          })
          .then((res) => {
            this.dadosFiliais = res.data;
          })
          .catch((e) => {
            this.dadosFiliais = [];

            this.snackbar.color = 'red';
            if (e.response.data.erro) {
              this.snackbar.text = `Faltando parâmetros obrigatórios, verifique!`;
            } else {
              this.snackbar.text = 'Erro, tente recarregar a pagina! :[listar]'
            }

            this.snackbar.status = true;
          })
          .finally(() => {
            this.carregando = false;
            this.carregandoSkeleton = false;
          });
    },

    listar2() {
      this.carregando = true;
      return axios
          .post(`${this.backendUrl}dashboard/marketing/tickets/ano/listar`, {
            idfilial: this.busca.idfiliais.join(',') || null,
            ano: this.busca.ano.toString() || null,
            ano_anterior: this.busca.ano.map(ano => ano - 1).toString() || null,
          })
          .then((res) => {
            this.dados = res.data;
            if (this.allCollapsed) {
              this.collapsedState = new Array(this.dados.vendas.length).fill(true);
            } else {
              this.collapsedState = new Array(this.dados.vendas.length).fill(false);
            }

            this.updateCharts();
          })
          .catch((e) => {
            // Simulação de dados da API
            var apiData
            if (this.busca.ano === "2025") {
              apiData = [{
                qtd_vendas: { janeiro: 10, fevereiro: 20, marco: 30 },
                valor_vendas: { janeiro: 1000, fevereiro: 2000, marco: 3000 },
                ticket_medio: { janeiro: 100, fevereiro: 150, marco: 200 },
                qtd_clientes: { janeiro: 5, fevereiro: 10, marco: 15 },
                media_ticket_clientes: { janeiro: 200, fevereiro: 250, marco: 300 },
              }];
            } else {
              apiData = [{
                qtd_vendas: {
                  janeiro: 10, fevereiro: 20, marco: 30, abril: 25, maio: 40, junho: 35,
                  julho: 50, agosto: 45, setembro: 55, outubro: 60, novembro: 65, dezembro: 70
                },
                valor_vendas: {
                  janeiro: 1000, fevereiro: 2000, marco: 3000, abril: 2500, maio: 4000, junho: 3500,
                  julho: 5000, agosto: 4500, setembro: 5500, outubro: 6000, novembro: 6500, dezembro: 7000
                },
                ticket_medio: {
                  janeiro: 100, fevereiro: 150, marco: 200, abril: 175, maio: 225, junho: 195,
                  julho: 250, agosto: 225, setembro: 275, outubro: 300, novembro: 325, dezembro: 350
                },
                qtd_clientes: {
                  janeiro: 5, fevereiro: 10, marco: 15, abril: 12, maio: 20, junho: 18,
                  julho: 25, agosto: 22, setembro: 28, outubro: 30, novembro: 32, dezembro: 35
                },
                media_ticket_clientes: {
                  janeiro: 200, fevereiro: 250, marco: 300, abril: 280, maio: 350, junho: 320,
                  julho: 400, agosto: 370, setembro: 420, outubro: 450, novembro: 480, dezembro: 500
                }
              }];
            }

            this.dados = apiData[0];

            this.snackbar.color = 'red';
            if (e.response.data.erro) {
              this.snackbar.text = `Faltando parâmetros obrigatórios, verifique!`;
            } else {
              this.snackbar.text = 'Erro, tente recarregar a pagina! :[listar]'
            }

            this.snackbar.status = true;
          })
          .finally(() => {
            this.carregando = false;
            this.carregandoSkeleton = false;
          });
    },

    updateCharts() {
      if (this.indicadorSelecionado) {
        // const indicador = this.colunas.find(
        //     (f) => f.valor === this.indicadorSelecionado
        // ).titulo;
        // console.log(indicador)

        // this.pieSeries = Object.values(this.meses.map(mes =>  this.dados[this.indicadorSelecionado][mes]))
        // this.pieOptions.labels = this.meses;

        this.lineSeries = this.dados.vendas.map((venda) => ({
          name: `${venda.ano}`,
          data: this.meses.map(mes => {
            const valor = venda[this.indicadorSelecionado][mes];
            return valor === 0 ? null : valor;
          })
        }));

        this.lineOptions.xaxis.categories = this.meses;

        this.barSeries = this.dados.vendas.map((venda) => ({
          name: `${venda.ano}`,
          data: this.meses.map(mes => venda[this.indicadorSelecionado][mes] || 0)
        }));

        this.barOptions.xaxis.categories = this.meses;
      }
    },

    generateColumnVisibilityHash(grupos) {
      return JSON.stringify(grupos.map(grupo => ({
        visible: grupo.visible,
        colunasVisible: grupo.colunas
            .filter(col => col.visible)
            .map(col => col.valor)
      })));
    },

    throttledHandleScroll() {
      if (!this.throttleTimer) {
        this.throttleTimer = setTimeout(() => {
          this.handleScroll();
          this.throttleTimer = null;
        }, 100);
      }
    },

    handleScroll() {
      const table = document.getElementById('minha-tabela');
      if (!table) return;

      const tableTop = table.getBoundingClientRect().top;
      const tableWidth = table.offsetWidth;

      // Calcula colunas visíveis
      const todasColunasVisiveis = this.gruposColunas.reduce((total, grupo) => {
        if (!grupo.visible) return total;
        const colunasVisiveisNoGrupo = grupo.colunas.filter(coluna => coluna.visible).length;
        return total + colunasVisiveisNoGrupo;
      }, 0);

      // Condições para tamanho de tela e colunas visíveis
      const colunasTamanhoCondition = (
          (todasColunasVisiveis <= 10 && this.$vuetify.breakpoint.width > 1300) ||
          todasColunasVisiveis <= 9 ||
          this.$vuetify.breakpoint.width > 1800
      );

      // Lógica de histerese
      if (!this.isHeaderFixed && tableTop <= this.fixationThreshold && colunasTamanhoCondition) {
        this.fixHeader(table, tableWidth);
      } else if (this.isHeaderFixed && (tableTop > this.releaseThreshold || !colunasTamanhoCondition)) {
        this.releaseHeader(table);
      } else if (this.isHeaderFixed) {
        // Mesmo que já esteja fixo, atualiza as larguras se houve mudança na visibilidade
        if (this.originalWidths === null) {
          this.storeOriginalWidths(table);
          this.adjustHeaderWidths(table, tableWidth);
        }
      }
    },

    fixHeader(table, tableWidth) {
      if (this.isHeaderFixed) return;

      this.isHeaderFixed = true;
      table.classList.add('fixed-header');

      // Armazena larguras atuais e ajustar o cabeçalho
      this.storeOriginalWidths(table);
      this.adjustHeaderWidths(table, tableWidth);

      // Adiciona listener para rolagem horizontal
      const tableWrapper = table.closest('.v-data-table__wrapper');
      if (tableWrapper) {
        tableWrapper.addEventListener('scroll', this.handleTableHorizontalScroll);
      }
    },

    releaseHeader(table) {
      if (!this.isHeaderFixed) return;

      this.isHeaderFixed = false;
      table.classList.remove('fixed-header');

      // Limpa larguras e estilos
      this.resetHeaderStyles(table);
      this.originalWidths = null;

      // Remove listener
      const tableWrapper = table.closest('.v-data-table__wrapper');
      if (tableWrapper) {
        tableWrapper.removeEventListener('scroll', this.handleTableHorizontalScroll);
      }
    },

    storeOriginalWidths(table) {
      this.originalWidths = [];

      // Captura apenas células visíveis no corpo da tabela
      const bodyCells = table.querySelectorAll('tbody tr:first-child td');
      const headerCells = table.querySelectorAll('thead th');

      // captura as larguras das células do corpo
      for (let i = 0; i < headerCells.length; i++) {
        // largura da célula do corpo
        const width = (i < bodyCells.length) ? bodyCells[i].offsetWidth : headerCells[i].offsetWidth;
        this.originalWidths.push(width);
      }
    },

    adjustHeaderWidths(table, tableWidth) {
      if (!this.originalWidths) return;

      const headerCells = table.querySelectorAll('thead th');
      const headerRow = table.querySelector('thead tr');

      // Aplica larguras armazenadas
      for (let i = 0; i < headerCells.length && i < this.originalWidths.length; i++) {
        headerCells[i].style.width = `${this.originalWidths[i]}px`;
      }

      if (headerRow) {
        headerRow.style.width = `${tableWidth}px`;
      }
    },

    resetHeaderStyles(table) {
      const headerCells = table.querySelectorAll('thead th');
      headerCells.forEach(cell => {
        cell.style.width = '';
      });

      const headerRow = table.querySelector('thead tr');
      if (headerRow) {
        headerRow.style.width = '';
        headerRow.style.transform = '';
      }
    },

    handleTableHorizontalScroll(event) {
      if (!this.isHeaderFixed) return;

      const scrollLeft = event.target.scrollLeft;
      const table = document.getElementById('minha-tabela');
      if (!table) return;

      const headerRow = table.querySelector('.fixed-header thead');
      if (headerRow) {
        headerRow.style.transform = `translateX(-${scrollLeft}px)`;
      }
    },

    async init() {
      this.getUltimaOuAtualQuinta();
      this.getProximaQuarta();
      this.atualizarPeriodo();
      //this.listar();
      //this.listarPrecargas();
      // await new Promise(resolve => setTimeout(resolve, 1000));
      // this.busca.idfiliais = await this.filiaisFiltro.map(item => item.idfilial);
      // await this.toggleSelectAll();
    }
  },
  // mounted() {
  //   window.addEventListener('scroll', this.throttledHandleScroll);
  //   window.addEventListener('resize', this.throttledHandleScroll);
  //
  //   // Calcula o hash inicial de visibilidade
  //   this.columnVisibilityHash = this.generateColumnVisibilityHash(this.gruposColunas);
  //
  //   // Inicializa após a renderização completa
  //   this.$nextTick(() => {
  //     this.handleScroll();
  //   });
  //
  //   this.gerarDiasDoMes('2025-02');
  // },
  //
  // beforeDestroy() {
  //   window.removeEventListener('scroll', this.throttledHandleScroll);
  //   window.removeEventListener('resize', this.throttledHandleScroll);
  //
  //   // Limpa cabeçalho fixo
  //   const table = document.getElementById('minha-tabela');
  //   if (table && this.isHeaderFixed) {
  //     this.releaseHeader(table);
  //   }
  // },

  created() {
    this.init();
  },
};
</script>

<style scoped>
.subtotal-row {
  background-color: #3A819F;
  font-weight: bold;
}

.total-row {
  background-color: #175874;
  font-weight: bold;
}


.lote-info {
  padding: 8px 12px;
  vertical-align: top;
  background-color: #f9f9f9;
  border-right: 1px solid #ddd;
  font-size: 14px;
}

.info-item {
  margin-bottom: 6px;
}

.info-item strong {
  color: #424242;
}

.hover-lote {
  background-color: rgba(2, 52, 73, 0.09) !important;
}


#minha-tabela {
  position: relative;
}

#minha-tabela.fixed-header thead {
  position: fixed;
  top: 62px; /* Sua posição desejada */
  z-index: 10;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: transform 0.1s ease; /* Suaviza a transição durante a rolagem horizontal */
}

/* Para evitar o pulo quando o header se torna fixo */
#minha-tabela.fixed-header::before {
  content: '';
  display: block;
  height: 48px; /* Ajuste para a altura do seu cabeçalho */
}

/* Garantir que a tabela tenha layout fixo para manter as larguras das colunas */
#minha-tabela,
#minha-tabela.fixed-header {
  table-layout: fixed;
}

.bordered-col {
  border: 1px solid #ddd !important;
}

.bordered-col2 {
  border-right: 1px solid #ddd !important;
  border-left: 1px solid #ddd !important;;
}

.bordered-col-error {
  border: 1px solid #ddd !important;
  color: red;
  background-color: #FFEBEE;
  border-radius: 2px;
}

.bordered-col-success {
  border: 1px solid #ddd !important;
  color: green;
  background-color: #E8F5E9;
  border-radius: 2px;
}

.bordered-col .v-card__subtitle{
  background-color: #f4f4f4 !important;
  font-weight: bold !important;
  text-align: center !important;
}

.bordered-table {
  border-collapse: collapse;
}

.bordered-table th,
.bordered-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.bordered-table th {
  background-color: #f4f4f4;
  font-weight: bold;
  text-align: left;
}

.active-btn {
  background-color: #3D7AA8 !important;
  color: white !important;
}

.active-btn2 {
  background-color: rgba(33, 150, 243, 0.1); /* Azul leve */
  border-color: #3D7AA8 !important; /* Azul do Vuetify */
  color: #3D7AA8 !important; /* Mantém o texto azul */

}

.fade-transition {
  transition: all 0.3s ease;
}

/* Quando o v-show é false */
.fade-transition[style*="display: none"] {
  opacity: 0;
  max-height: 0;
  transform: translateY(-10px);
}

/* Estados iniciais/finais para o v-show */
.fade-transition {
  opacity: 1;
  max-height: 100px;
  transform: translateY(0);
}

/* Zebra striping */
#minha-tabela tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

#minha-tabela tbody tr:nth-child(even) {
  background-color: #f4f4f4;
}

/* Hover: mantém o efeito mesmo com zebra */
#minha-tabela tbody tr:hover {
  background-color: rgba(2, 52, 73, 0.09) !important;
}

/* Bordas verticais */
#minha-tabela td,
#minha-tabela th {
  border-right: 1px solid #e0e0e0;
}

/* Remove borda da última célula */
#minha-tabela td:last-child,
#minha-tabela th:last-child {
  border-right: none;
}

.scroll-cores {
  scrollbar-color: #023449 white;
  scrollbar-width: thin;
}

.border-dialog-card {
  border: 2px solid #023449;
  border-right: 0px;
}
</style>
